import { jsx as h, jsxs as E, Fragment as Ft } from "react/jsx-runtime";
import * as Pe from "react";
import B, { useState as oe, useRef as rt, useCallback as le, createContext as ir, useMemo as We, forwardRef as De, useContext as Lt, useEffect as ce, createElement as br, Children as Xt, cloneElement as yr, isValidElement as wr, useImperativeHandle as kn, useId as En } from "react";
import { twJoin as F, twMerge as be } from "tailwind-merge";
import * as Si from "react-dom";
import { createPortal as Ai } from "react-dom";
function ot({
  value: e,
  defaultValue: t,
  onStateChange: r
} = {}) {
  const [n, i] = oe(t), { current: s } = rt(e != null), o = s ? e : n, a = le(
    (l) => {
      s || i(l), r == null || r(l);
    },
    [s, r, i]
  );
  return [o, a];
}
const xr = ir({
  disabled: !1,
  expanded: !1
});
function Ya({
  expanded: e,
  defaultExpanded: t,
  onChange: r,
  className: n,
  disabled: i = !1,
  children: s
}) {
  const [o = !1, a] = ot({
    value: e,
    defaultValue: t,
    onStateChange: r
  }), l = le(() => {
    a(!o);
  }, [a, o]), u = We(
    () => ({
      defaultExpanded: t,
      disabled: i,
      expanded: o && !i,
      toggle: i ? void 0 : l
    }),
    [t, o, i, l]
  );
  return /* @__PURE__ */ h(xr.Provider, { value: u, children: /* @__PURE__ */ h("div", { className: F("bbn-accordion", i && "bbn-accordion-disabled", n), children: s }) });
}
const at = De(
  ({ variant: e = "contained", size: t = "large", color: r = "primary", fluid: n = !1, className: i, disabled: s, ...o }, a) => /* @__PURE__ */ h(
    "button",
    {
      ...o,
      disabled: s,
      ref: a,
      className: F(
        "bbn-btn",
        `bbn-btn-${e}`,
        `bbn-btn-${r}`,
        `bbn-btn-${t}`,
        n && "bbn-btn-fluid",
        i
      )
    }
  )
);
at.displayName = "Button";
const Sn = ({ className: e, ...t }) => /* @__PURE__ */ h("button", { ...t, className: F("bbn-btn-icon", e) }), Fi = De(
  ({ className: e, ...t }, r) => /* @__PURE__ */ h(
    at,
    {
      ...t,
      ref: r,
      variant: "contained",
      className: F(
        "!bg-error-main text-white font-medium !text-sm hover:!bg-error-main/90 transition-colors",
        e
      )
    }
  )
);
Fi.displayName = "WalletDisconnectButton";
function Ga({
  className: e,
  iconClassName: t,
  children: r,
  renderIcon: n = () => null
}) {
  const { expanded: i, toggle: s } = Lt(xr), o = n(i);
  return /* @__PURE__ */ E("div", { className: F("bbn-accordion-summary", e), onClick: s, children: [
    r,
    o && /* @__PURE__ */ h(Sn, { className: F("bbn-accordion-icon", t), children: o })
  ] });
}
function Cr(e, t) {
  return typeof e != "number" ? typeof t == "number" ? Cr(t) : t : `${e}px`;
}
function Li(e = !0) {
  const [t, r] = oe("0px"), [n, i] = oe(), s = rt(null);
  return ce(() => {
    const o = new ResizeObserver((a) => {
      const [l] = a;
      r(Cr(l.target.clientHeight) ?? "0px");
    });
    i(o);
  }, []), ce(
    function() {
      const { current: a } = s;
      if (!(!e || !a))
        return n == null || n.observe(a), () => {
          n == null || n.unobserve(a);
        };
    },
    [e, n]
  ), { height: t, ref: s };
}
function Ka({
  unmountOnExit: e = !1,
  animationDuration: t = 200,
  className: r,
  wrapperClassName: n,
  children: i
}) {
  const { expanded: s } = Lt(xr), [o, a] = oe(s), l = o || !e, { height: u, ref: c } = Li(l);
  return ce(
    function() {
      if (s === o)
        return;
      if (s) {
        a(!0);
        return;
      }
      const p = setTimeout(a, t, !1);
      return () => {
        clearTimeout(p);
      };
    },
    [s, o, t]
  ), /* @__PURE__ */ h(
    "div",
    {
      className: F("bbn-accordion-details", n),
      style: {
        height: s ? u : "0px",
        visibility: o ? "visible" : "hidden",
        transitionDuration: `${t}ms`
      },
      children: l ? /* @__PURE__ */ h("div", { ref: c, className: F("bbn-accordion-content", r), children: i }) : null
    }
  );
}
const X = De(
  ({ variant: e = "body1", as: t = "p", children: r, className: n, ...i }, s) => br(
    t,
    {
      ...i,
      ref: s,
      className: F(`bbn-text-${e}`, n)
    },
    r
  )
);
X.displayName = "Text";
const Nr = De(
  ({ variant: e, as: t = e, children: r, className: n, ...i }, s) => br(
    t,
    {
      ...i,
      ref: s,
      className: F(`bbn-${e}`, n)
    },
    r
  )
);
Nr.displayName = "Heading";
function pr({ className: e, style: t, size: r = "large", variant: n = "circular", alt: i, url: s, children: o }) {
  return /* @__PURE__ */ h("div", { style: t, className: F("bbn-avatar", `bbn-avatar-${r}`, `bbn-avatar-${n}`, e), children: s ? /* @__PURE__ */ h("img", { className: "bbn-avatar-img", src: s, alt: i }) : o });
}
const Ja = ({
  max: e = 1 / 0,
  className: t,
  children: r,
  avatarClassName: n,
  variant: i,
  ...s
}) => {
  const o = Xt.count(r);
  return /* @__PURE__ */ E("div", { className: F("bbn-avatar-group", t), children: [
    Xt.map(
      r,
      (a, l) => wr(a) && l + 1 <= e ? yr(a, {
        ...s,
        className: be(n, a.props.className),
        variant: i
      }) : null
    ),
    o > e && /* @__PURE__ */ E(pr, { size: s.size, variant: i, className: n, children: [
      "+",
      o - e
    ] })
  ] });
}, An = De(function({
  label: t,
  checked: r,
  defaultChecked: n = !1,
  inputProps: i,
  orientation: s = "left",
  disabled: o = !1,
  className: a,
  inputType: l,
  labelClassName: u,
  renderIcon: c,
  onChange: f,
  ...p
}, m) {
  const [C = !1, b] = ot({
    value: r,
    defaultValue: n,
    onStateChange: f
  });
  function y(w) {
    var M;
    b(w.currentTarget.checked), (M = i == null ? void 0 : i.onChange) == null || M.call(i, w);
  }
  const _ = /* @__PURE__ */ E("span", { className: F("bbn-switcher", o && "bbn-switcher-disabled", a), children: [
    c(C),
    /* @__PURE__ */ h(
      "input",
      {
        ref: m,
        type: l,
        disabled: o,
        className: "bbn-switcher-input",
        ...p,
        ...i,
        checked: C,
        onChange: y
      }
    )
  ] });
  return t ? /* @__PURE__ */ E(
    X,
    {
      as: "label",
      variant: "body1",
      className: F(
        "bbn-switcher-label",
        s === "left" ? "bbn-switcher-left" : "bbn-switcher-right",
        u
      ),
      children: [
        _,
        t
      ]
    }
  ) : _;
}), Vi = {
  false: /* @__PURE__ */ h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ h(
    "path",
    {
      d: "M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z",
      fill: "currentColor"
    }
  ) }),
  true: /* @__PURE__ */ h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ h(
    "path",
    {
      d: "M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.11 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z",
      fill: "currentColor"
    }
  ) })
}, _i = De(function(t, r) {
  return /* @__PURE__ */ h(An, { ref: r, ...t, inputType: "checkbox", renderIcon: (n) => Vi[n.toString()] });
}), Di = {
  true: /* @__PURE__ */ h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ h(
    "path",
    {
      d: "M12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C14.76 17 17 14.76 17 12C17 9.24 14.76 7 12 7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
      fill: "currentColor"
    }
  ) }),
  false: /* @__PURE__ */ h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ h(
    "path",
    {
      d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
      fill: "currentColor"
    }
  ) })
}, Ti = De(function(t, r) {
  return /* @__PURE__ */ h(An, { ref: r, ...t, inputType: "radio", renderIcon: (n) => Di[n.toString()] });
});
var Fn = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, Xr = B.createContext && /* @__PURE__ */ B.createContext(Fn), Mi = ["attr", "size", "title"];
function Pi(e, t) {
  if (e == null) return {};
  var r = Ri(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (i = 0; i < s.length; i++)
      n = s[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Ri(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Yt() {
  return Yt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Yt.apply(this, arguments);
}
function Yr(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Gt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Yr(Object(r), !0).forEach(function(n) {
      Bi(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Yr(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Bi(e, t, r) {
  return t = ji(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function ji(e) {
  var t = Ii(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Ii(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Ln(e) {
  return e && e.map((t, r) => /* @__PURE__ */ B.createElement(t.tag, Gt({
    key: r
  }, t.attr), Ln(t.child)));
}
function Vt(e) {
  return (t) => /* @__PURE__ */ B.createElement($i, Yt({
    attr: Gt({}, e.attr)
  }, t), Ln(e.child));
}
function $i(e) {
  var t = (r) => {
    var {
      attr: n,
      size: i,
      title: s
    } = e, o = Pi(e, Mi), a = i || r.size || "1em", l;
    return r.className && (l = r.className), e.className && (l = (l ? l + " " : "") + e.className), /* @__PURE__ */ B.createElement("svg", Yt({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, r.attr, n, o, {
      className: l,
      style: Gt(Gt({
        color: e.color || r.color
      }, r.style), e.style),
      height: a,
      width: a,
      xmlns: "http://www.w3.org/2000/svg"
    }), s && /* @__PURE__ */ B.createElement("title", null, s), e.children);
  };
  return Xr !== void 0 ? /* @__PURE__ */ B.createElement(Xr.Consumer, null, (r) => t(r)) : t(Fn);
}
function Hi(e) {
  return Vt({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M12 16L6 10H18L12 16Z" }, child: [] }] })(e);
}
function Ui(e) {
  return Vt({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M11.9999 13.1714L16.9497 8.22168L18.3639 9.63589L11.9999 15.9999L5.63599 9.63589L7.0502 8.22168L11.9999 13.1714Z" }, child: [] }] })(e);
}
function Wi(e) {
  return Vt({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M12 8L18 14H6L12 8Z" }, child: [] }] })(e);
}
var Gr = function(t) {
  return t.reduce(function(r, n) {
    var i = n[0], s = n[1];
    return r[i] = s, r;
  }, {});
}, Kr = typeof window < "u" && window.document && window.document.createElement ? Pe.useLayoutEffect : Pe.useEffect, de = "top", we = "bottom", xe = "right", he = "left", Or = "auto", _t = [de, we, xe, he], lt = "start", kt = "end", qi = "clippingParents", Vn = "viewport", bt = "popper", zi = "reference", Jr = /* @__PURE__ */ _t.reduce(function(e, t) {
  return e.concat([t + "-" + lt, t + "-" + kt]);
}, []), _n = /* @__PURE__ */ [].concat(_t, [Or]).reduce(function(e, t) {
  return e.concat([t, t + "-" + lt, t + "-" + kt]);
}, []), Zi = "beforeRead", Xi = "read", Yi = "afterRead", Gi = "beforeMain", Ki = "main", Ji = "afterMain", Qi = "beforeWrite", es = "write", ts = "afterWrite", rs = [Zi, Xi, Yi, Gi, Ki, Ji, Qi, es, ts];
function Ve(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function me(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function et(e) {
  var t = me(e).Element;
  return e instanceof t || e instanceof Element;
}
function ye(e) {
  var t = me(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function kr(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = me(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function ns(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var n = t.styles[r] || {}, i = t.attributes[r] || {}, s = t.elements[r];
    !ye(s) || !Ve(s) || (Object.assign(s.style, n), Object.keys(i).forEach(function(o) {
      var a = i[o];
      a === !1 ? s.removeAttribute(o) : s.setAttribute(o, a === !0 ? "" : a);
    }));
  });
}
function is(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var i = t.elements[n], s = t.attributes[n] || {}, o = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : r[n]), a = o.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !ye(i) || !Ve(i) || (Object.assign(i.style, a), Object.keys(s).forEach(function(l) {
        i.removeAttribute(l);
      }));
    });
  };
}
const ss = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: ns,
  effect: is,
  requires: ["computeStyles"]
};
function Le(e) {
  return e.split("-")[0];
}
var Je = Math.max, Kt = Math.min, ct = Math.round;
function vr() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Dn() {
  return !/^((?!chrome|android).)*safari/i.test(vr());
}
function ut(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var n = e.getBoundingClientRect(), i = 1, s = 1;
  t && ye(e) && (i = e.offsetWidth > 0 && ct(n.width) / e.offsetWidth || 1, s = e.offsetHeight > 0 && ct(n.height) / e.offsetHeight || 1);
  var o = et(e) ? me(e) : window, a = o.visualViewport, l = !Dn() && r, u = (n.left + (l && a ? a.offsetLeft : 0)) / i, c = (n.top + (l && a ? a.offsetTop : 0)) / s, f = n.width / i, p = n.height / s;
  return {
    width: f,
    height: p,
    top: c,
    right: u + f,
    bottom: c + p,
    left: u,
    x: u,
    y: c
  };
}
function Er(e) {
  var t = ut(e), r = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: n
  };
}
function Tn(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && kr(r)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function Be(e) {
  return me(e).getComputedStyle(e);
}
function os(e) {
  return ["table", "td", "th"].indexOf(Ve(e)) >= 0;
}
function qe(e) {
  return ((et(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function sr(e) {
  return Ve(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (kr(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    qe(e)
  );
}
function Qr(e) {
  return !ye(e) || // https://github.com/popperjs/popper-core/issues/837
  Be(e).position === "fixed" ? null : e.offsetParent;
}
function as(e) {
  var t = /firefox/i.test(vr()), r = /Trident/i.test(vr());
  if (r && ye(e)) {
    var n = Be(e);
    if (n.position === "fixed")
      return null;
  }
  var i = sr(e);
  for (kr(i) && (i = i.host); ye(i) && ["html", "body"].indexOf(Ve(i)) < 0; ) {
    var s = Be(i);
    if (s.transform !== "none" || s.perspective !== "none" || s.contain === "paint" || ["transform", "perspective"].indexOf(s.willChange) !== -1 || t && s.willChange === "filter" || t && s.filter && s.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function Dt(e) {
  for (var t = me(e), r = Qr(e); r && os(r) && Be(r).position === "static"; )
    r = Qr(r);
  return r && (Ve(r) === "html" || Ve(r) === "body" && Be(r).position === "static") ? t : r || as(e) || t;
}
function Sr(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function xt(e, t, r) {
  return Je(e, Kt(t, r));
}
function ls(e, t, r) {
  var n = xt(e, t, r);
  return n > r ? r : n;
}
function Mn() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Pn(e) {
  return Object.assign({}, Mn(), e);
}
function Rn(e, t) {
  return t.reduce(function(r, n) {
    return r[n] = e, r;
  }, {});
}
var cs = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, Pn(typeof t != "number" ? t : Rn(t, _t));
};
function us(e) {
  var t, r = e.state, n = e.name, i = e.options, s = r.elements.arrow, o = r.modifiersData.popperOffsets, a = Le(r.placement), l = Sr(a), u = [he, xe].indexOf(a) >= 0, c = u ? "height" : "width";
  if (!(!s || !o)) {
    var f = cs(i.padding, r), p = Er(s), m = l === "y" ? de : he, C = l === "y" ? we : xe, b = r.rects.reference[c] + r.rects.reference[l] - o[l] - r.rects.popper[c], y = o[l] - r.rects.reference[l], _ = Dt(s), w = _ ? l === "y" ? _.clientHeight || 0 : _.clientWidth || 0 : 0, M = b / 2 - y / 2, S = f[m], L = w - p[c] - f[C], V = w / 2 - p[c] / 2 + M, O = xt(S, V, L), $ = l;
    r.modifiersData[n] = (t = {}, t[$] = O, t.centerOffset = O - V, t);
  }
}
function fs(e) {
  var t = e.state, r = e.options, n = r.element, i = n === void 0 ? "[data-popper-arrow]" : n;
  i != null && (typeof i == "string" && (i = t.elements.popper.querySelector(i), !i) || Tn(t.elements.popper, i) && (t.elements.arrow = i));
}
const ds = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: us,
  effect: fs,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function ft(e) {
  return e.split("-")[1];
}
var hs = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function ps(e, t) {
  var r = e.x, n = e.y, i = t.devicePixelRatio || 1;
  return {
    x: ct(r * i) / i || 0,
    y: ct(n * i) / i || 0
  };
}
function en(e) {
  var t, r = e.popper, n = e.popperRect, i = e.placement, s = e.variation, o = e.offsets, a = e.position, l = e.gpuAcceleration, u = e.adaptive, c = e.roundOffsets, f = e.isFixed, p = o.x, m = p === void 0 ? 0 : p, C = o.y, b = C === void 0 ? 0 : C, y = typeof c == "function" ? c({
    x: m,
    y: b
  }) : {
    x: m,
    y: b
  };
  m = y.x, b = y.y;
  var _ = o.hasOwnProperty("x"), w = o.hasOwnProperty("y"), M = he, S = de, L = window;
  if (u) {
    var V = Dt(r), O = "clientHeight", $ = "clientWidth";
    if (V === me(r) && (V = qe(r), Be(V).position !== "static" && a === "absolute" && (O = "scrollHeight", $ = "scrollWidth")), V = V, i === de || (i === he || i === xe) && s === kt) {
      S = we;
      var j = f && V === L && L.visualViewport ? L.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        V[O]
      );
      b -= j - n.height, b *= l ? 1 : -1;
    }
    if (i === he || (i === de || i === we) && s === kt) {
      M = xe;
      var H = f && V === L && L.visualViewport ? L.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        V[$]
      );
      m -= H - n.width, m *= l ? 1 : -1;
    }
  }
  var R = Object.assign({
    position: a
  }, u && hs), D = c === !0 ? ps({
    x: m,
    y: b
  }, me(r)) : {
    x: m,
    y: b
  };
  if (m = D.x, b = D.y, l) {
    var I;
    return Object.assign({}, R, (I = {}, I[S] = w ? "0" : "", I[M] = _ ? "0" : "", I.transform = (L.devicePixelRatio || 1) <= 1 ? "translate(" + m + "px, " + b + "px)" : "translate3d(" + m + "px, " + b + "px, 0)", I));
  }
  return Object.assign({}, R, (t = {}, t[S] = w ? b + "px" : "", t[M] = _ ? m + "px" : "", t.transform = "", t));
}
function vs(e) {
  var t = e.state, r = e.options, n = r.gpuAcceleration, i = n === void 0 ? !0 : n, s = r.adaptive, o = s === void 0 ? !0 : s, a = r.roundOffsets, l = a === void 0 ? !0 : a, u = {
    placement: Le(t.placement),
    variation: ft(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: i,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, en(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: o,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, en(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const ms = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: vs,
  data: {}
};
var Ut = {
  passive: !0
};
function gs(e) {
  var t = e.state, r = e.instance, n = e.options, i = n.scroll, s = i === void 0 ? !0 : i, o = n.resize, a = o === void 0 ? !0 : o, l = me(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return s && u.forEach(function(c) {
    c.addEventListener("scroll", r.update, Ut);
  }), a && l.addEventListener("resize", r.update, Ut), function() {
    s && u.forEach(function(c) {
      c.removeEventListener("scroll", r.update, Ut);
    }), a && l.removeEventListener("resize", r.update, Ut);
  };
}
const bs = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: gs,
  data: {}
};
var ys = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function qt(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return ys[t];
  });
}
var ws = {
  start: "end",
  end: "start"
};
function tn(e) {
  return e.replace(/start|end/g, function(t) {
    return ws[t];
  });
}
function Ar(e) {
  var t = me(e), r = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function Fr(e) {
  return ut(qe(e)).left + Ar(e).scrollLeft;
}
function xs(e, t) {
  var r = me(e), n = qe(e), i = r.visualViewport, s = n.clientWidth, o = n.clientHeight, a = 0, l = 0;
  if (i) {
    s = i.width, o = i.height;
    var u = Dn();
    (u || !u && t === "fixed") && (a = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: s,
    height: o,
    x: a + Fr(e),
    y: l
  };
}
function Cs(e) {
  var t, r = qe(e), n = Ar(e), i = (t = e.ownerDocument) == null ? void 0 : t.body, s = Je(r.scrollWidth, r.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), o = Je(r.scrollHeight, r.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), a = -n.scrollLeft + Fr(e), l = -n.scrollTop;
  return Be(i || r).direction === "rtl" && (a += Je(r.clientWidth, i ? i.clientWidth : 0) - s), {
    width: s,
    height: o,
    x: a,
    y: l
  };
}
function Lr(e) {
  var t = Be(e), r = t.overflow, n = t.overflowX, i = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + i + n);
}
function Bn(e) {
  return ["html", "body", "#document"].indexOf(Ve(e)) >= 0 ? e.ownerDocument.body : ye(e) && Lr(e) ? e : Bn(sr(e));
}
function Ct(e, t) {
  var r;
  t === void 0 && (t = []);
  var n = Bn(e), i = n === ((r = e.ownerDocument) == null ? void 0 : r.body), s = me(n), o = i ? [s].concat(s.visualViewport || [], Lr(n) ? n : []) : n, a = t.concat(o);
  return i ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(Ct(sr(o)))
  );
}
function mr(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Ns(e, t) {
  var r = ut(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function rn(e, t, r) {
  return t === Vn ? mr(xs(e, r)) : et(t) ? Ns(t, r) : mr(Cs(qe(e)));
}
function Os(e) {
  var t = Ct(sr(e)), r = ["absolute", "fixed"].indexOf(Be(e).position) >= 0, n = r && ye(e) ? Dt(e) : e;
  return et(n) ? t.filter(function(i) {
    return et(i) && Tn(i, n) && Ve(i) !== "body";
  }) : [];
}
function ks(e, t, r, n) {
  var i = t === "clippingParents" ? Os(e) : [].concat(t), s = [].concat(i, [r]), o = s[0], a = s.reduce(function(l, u) {
    var c = rn(e, u, n);
    return l.top = Je(c.top, l.top), l.right = Kt(c.right, l.right), l.bottom = Kt(c.bottom, l.bottom), l.left = Je(c.left, l.left), l;
  }, rn(e, o, n));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function jn(e) {
  var t = e.reference, r = e.element, n = e.placement, i = n ? Le(n) : null, s = n ? ft(n) : null, o = t.x + t.width / 2 - r.width / 2, a = t.y + t.height / 2 - r.height / 2, l;
  switch (i) {
    case de:
      l = {
        x: o,
        y: t.y - r.height
      };
      break;
    case we:
      l = {
        x: o,
        y: t.y + t.height
      };
      break;
    case xe:
      l = {
        x: t.x + t.width,
        y: a
      };
      break;
    case he:
      l = {
        x: t.x - r.width,
        y: a
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var u = i ? Sr(i) : null;
  if (u != null) {
    var c = u === "y" ? "height" : "width";
    switch (s) {
      case lt:
        l[u] = l[u] - (t[c] / 2 - r[c] / 2);
        break;
      case kt:
        l[u] = l[u] + (t[c] / 2 - r[c] / 2);
        break;
    }
  }
  return l;
}
function Et(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, i = n === void 0 ? e.placement : n, s = r.strategy, o = s === void 0 ? e.strategy : s, a = r.boundary, l = a === void 0 ? qi : a, u = r.rootBoundary, c = u === void 0 ? Vn : u, f = r.elementContext, p = f === void 0 ? bt : f, m = r.altBoundary, C = m === void 0 ? !1 : m, b = r.padding, y = b === void 0 ? 0 : b, _ = Pn(typeof y != "number" ? y : Rn(y, _t)), w = p === bt ? zi : bt, M = e.rects.popper, S = e.elements[C ? w : p], L = ks(et(S) ? S : S.contextElement || qe(e.elements.popper), l, c, o), V = ut(e.elements.reference), O = jn({
    reference: V,
    element: M,
    placement: i
  }), $ = mr(Object.assign({}, M, O)), j = p === bt ? $ : V, H = {
    top: L.top - j.top + _.top,
    bottom: j.bottom - L.bottom + _.bottom,
    left: L.left - j.left + _.left,
    right: j.right - L.right + _.right
  }, R = e.modifiersData.offset;
  if (p === bt && R) {
    var D = R[i];
    Object.keys(H).forEach(function(I) {
      var W = [xe, we].indexOf(I) >= 0 ? 1 : -1, J = [de, we].indexOf(I) >= 0 ? "y" : "x";
      H[I] += D[J] * W;
    });
  }
  return H;
}
function Es(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, i = r.boundary, s = r.rootBoundary, o = r.padding, a = r.flipVariations, l = r.allowedAutoPlacements, u = l === void 0 ? _n : l, c = ft(n), f = c ? a ? Jr : Jr.filter(function(C) {
    return ft(C) === c;
  }) : _t, p = f.filter(function(C) {
    return u.indexOf(C) >= 0;
  });
  p.length === 0 && (p = f);
  var m = p.reduce(function(C, b) {
    return C[b] = Et(e, {
      placement: b,
      boundary: i,
      rootBoundary: s,
      padding: o
    })[Le(b)], C;
  }, {});
  return Object.keys(m).sort(function(C, b) {
    return m[C] - m[b];
  });
}
function Ss(e) {
  if (Le(e) === Or)
    return [];
  var t = qt(e);
  return [tn(e), t, tn(t)];
}
function As(e) {
  var t = e.state, r = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var i = r.mainAxis, s = i === void 0 ? !0 : i, o = r.altAxis, a = o === void 0 ? !0 : o, l = r.fallbackPlacements, u = r.padding, c = r.boundary, f = r.rootBoundary, p = r.altBoundary, m = r.flipVariations, C = m === void 0 ? !0 : m, b = r.allowedAutoPlacements, y = t.options.placement, _ = Le(y), w = _ === y, M = l || (w || !C ? [qt(y)] : Ss(y)), S = [y].concat(M).reduce(function(je, Ne) {
      return je.concat(Le(Ne) === Or ? Es(t, {
        placement: Ne,
        boundary: c,
        rootBoundary: f,
        padding: u,
        flipVariations: C,
        allowedAutoPlacements: b
      }) : Ne);
    }, []), L = t.rects.reference, V = t.rects.popper, O = /* @__PURE__ */ new Map(), $ = !0, j = S[0], H = 0; H < S.length; H++) {
      var R = S[H], D = Le(R), I = ft(R) === lt, W = [de, we].indexOf(D) >= 0, J = W ? "width" : "height", Z = Et(t, {
        placement: R,
        boundary: c,
        rootBoundary: f,
        altBoundary: p,
        padding: u
      }), Q = W ? I ? xe : he : I ? we : de;
      L[J] > V[J] && (Q = qt(Q));
      var Ee = qt(Q), ue = [];
      if (s && ue.push(Z[D] <= 0), a && ue.push(Z[Q] <= 0, Z[Ee] <= 0), ue.every(function(je) {
        return je;
      })) {
        j = R, $ = !1;
        break;
      }
      O.set(R, ue);
    }
    if ($)
      for (var Te = C ? 3 : 1, it = function(Ne) {
        var Xe = S.find(function(Ie) {
          var Se = O.get(Ie);
          if (Se)
            return Se.slice(0, Ne).every(function(Ye) {
              return Ye;
            });
        });
        if (Xe)
          return j = Xe, "break";
      }, ze = Te; ze > 0; ze--) {
        var Ze = it(ze);
        if (Ze === "break") break;
      }
    t.placement !== j && (t.modifiersData[n]._skip = !0, t.placement = j, t.reset = !0);
  }
}
const Fs = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: As,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function nn(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function sn(e) {
  return [de, xe, we, he].some(function(t) {
    return e[t] >= 0;
  });
}
function Ls(e) {
  var t = e.state, r = e.name, n = t.rects.reference, i = t.rects.popper, s = t.modifiersData.preventOverflow, o = Et(t, {
    elementContext: "reference"
  }), a = Et(t, {
    altBoundary: !0
  }), l = nn(o, n), u = nn(a, i, s), c = sn(l), f = sn(u);
  t.modifiersData[r] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: u,
    isReferenceHidden: c,
    hasPopperEscaped: f
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": f
  });
}
const Vs = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Ls
};
function _s(e, t, r) {
  var n = Le(e), i = [he, de].indexOf(n) >= 0 ? -1 : 1, s = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, o = s[0], a = s[1];
  return o = o || 0, a = (a || 0) * i, [he, xe].indexOf(n) >= 0 ? {
    x: a,
    y: o
  } : {
    x: o,
    y: a
  };
}
function Ds(e) {
  var t = e.state, r = e.options, n = e.name, i = r.offset, s = i === void 0 ? [0, 0] : i, o = _n.reduce(function(c, f) {
    return c[f] = _s(f, t.rects, s), c;
  }, {}), a = o[t.placement], l = a.x, u = a.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += u), t.modifiersData[n] = o;
}
const Ts = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Ds
};
function Ms(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = jn({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const Ps = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Ms,
  data: {}
};
function Rs(e) {
  return e === "x" ? "y" : "x";
}
function Bs(e) {
  var t = e.state, r = e.options, n = e.name, i = r.mainAxis, s = i === void 0 ? !0 : i, o = r.altAxis, a = o === void 0 ? !1 : o, l = r.boundary, u = r.rootBoundary, c = r.altBoundary, f = r.padding, p = r.tether, m = p === void 0 ? !0 : p, C = r.tetherOffset, b = C === void 0 ? 0 : C, y = Et(t, {
    boundary: l,
    rootBoundary: u,
    padding: f,
    altBoundary: c
  }), _ = Le(t.placement), w = ft(t.placement), M = !w, S = Sr(_), L = Rs(S), V = t.modifiersData.popperOffsets, O = t.rects.reference, $ = t.rects.popper, j = typeof b == "function" ? b(Object.assign({}, t.rects, {
    placement: t.placement
  })) : b, H = typeof j == "number" ? {
    mainAxis: j,
    altAxis: j
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, j), R = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, D = {
    x: 0,
    y: 0
  };
  if (V) {
    if (s) {
      var I, W = S === "y" ? de : he, J = S === "y" ? we : xe, Z = S === "y" ? "height" : "width", Q = V[S], Ee = Q + y[W], ue = Q - y[J], Te = m ? -$[Z] / 2 : 0, it = w === lt ? O[Z] : $[Z], ze = w === lt ? -$[Z] : -O[Z], Ze = t.elements.arrow, je = m && Ze ? Er(Ze) : {
        width: 0,
        height: 0
      }, Ne = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Mn(), Xe = Ne[W], Ie = Ne[J], Se = xt(0, O[Z], je[Z]), Ye = M ? O[Z] / 2 - Te - Se - Xe - H.mainAxis : it - Se - Xe - H.mainAxis, mt = M ? -O[Z] / 2 + Te + Se + Ie + H.mainAxis : ze + Se + Ie + H.mainAxis, gt = t.elements.arrow && Dt(t.elements.arrow), Mt = gt ? S === "y" ? gt.clientTop || 0 : gt.clientLeft || 0 : 0, Pt = (I = R == null ? void 0 : R[S]) != null ? I : 0, Rt = Q + Ye - Pt - Mt, Bt = Q + mt - Pt, jt = xt(m ? Kt(Ee, Rt) : Ee, Q, m ? Je(ue, Bt) : ue);
      V[S] = jt, D[S] = jt - Q;
    }
    if (a) {
      var It, qr = S === "x" ? de : he, $t = S === "x" ? we : xe, d = V[L], v = L === "y" ? "height" : "width", g = d + y[qr], A = d - y[$t], N = [de, he].indexOf(_) !== -1, x = (It = R == null ? void 0 : R[L]) != null ? It : 0, P = N ? g : d - O[v] - $[v] - x + H.altAxis, U = N ? d + O[v] + $[v] - x - H.altAxis : A, q = m && N ? ls(P, d, U) : xt(m ? P : g, d, m ? U : A);
      V[L] = q, D[L] = q - d;
    }
    t.modifiersData[n] = D;
  }
}
const js = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Bs,
  requiresIfExists: ["offset"]
};
function Is(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function $s(e) {
  return e === me(e) || !ye(e) ? Ar(e) : Is(e);
}
function Hs(e) {
  var t = e.getBoundingClientRect(), r = ct(t.width) / e.offsetWidth || 1, n = ct(t.height) / e.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function Us(e, t, r) {
  r === void 0 && (r = !1);
  var n = ye(t), i = ye(t) && Hs(t), s = qe(t), o = ut(e, i, r), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((Ve(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Lr(s)) && (a = $s(t)), ye(t) ? (l = ut(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : s && (l.x = Fr(s))), {
    x: o.left + a.scrollLeft - l.x,
    y: o.top + a.scrollTop - l.y,
    width: o.width,
    height: o.height
  };
}
function Ws(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(s) {
    t.set(s.name, s);
  });
  function i(s) {
    r.add(s.name);
    var o = [].concat(s.requires || [], s.requiresIfExists || []);
    o.forEach(function(a) {
      if (!r.has(a)) {
        var l = t.get(a);
        l && i(l);
      }
    }), n.push(s);
  }
  return e.forEach(function(s) {
    r.has(s.name) || i(s);
  }), n;
}
function qs(e) {
  var t = Ws(e);
  return rs.reduce(function(r, n) {
    return r.concat(t.filter(function(i) {
      return i.phase === n;
    }));
  }, []);
}
function zs(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function Zs(e) {
  var t = e.reduce(function(r, n) {
    var i = r[n.name];
    return r[n.name] = i ? Object.assign({}, i, n, {
      options: Object.assign({}, i.options, n.options),
      data: Object.assign({}, i.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var on = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function an() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function Xs(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, n = r === void 0 ? [] : r, i = t.defaultOptions, s = i === void 0 ? on : i;
  return function(a, l, u) {
    u === void 0 && (u = s);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, on, s),
      modifiersData: {},
      elements: {
        reference: a,
        popper: l
      },
      attributes: {},
      styles: {}
    }, f = [], p = !1, m = {
      state: c,
      setOptions: function(_) {
        var w = typeof _ == "function" ? _(c.options) : _;
        b(), c.options = Object.assign({}, s, c.options, w), c.scrollParents = {
          reference: et(a) ? Ct(a) : a.contextElement ? Ct(a.contextElement) : [],
          popper: Ct(l)
        };
        var M = qs(Zs([].concat(n, c.options.modifiers)));
        return c.orderedModifiers = M.filter(function(S) {
          return S.enabled;
        }), C(), m.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!p) {
          var _ = c.elements, w = _.reference, M = _.popper;
          if (an(w, M)) {
            c.rects = {
              reference: Us(w, Dt(M), c.options.strategy === "fixed"),
              popper: Er(M)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(H) {
              return c.modifiersData[H.name] = Object.assign({}, H.data);
            });
            for (var S = 0; S < c.orderedModifiers.length; S++) {
              if (c.reset === !0) {
                c.reset = !1, S = -1;
                continue;
              }
              var L = c.orderedModifiers[S], V = L.fn, O = L.options, $ = O === void 0 ? {} : O, j = L.name;
              typeof V == "function" && (c = V({
                state: c,
                options: $,
                name: j,
                instance: m
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: zs(function() {
        return new Promise(function(y) {
          m.forceUpdate(), y(c);
        });
      }),
      destroy: function() {
        b(), p = !0;
      }
    };
    if (!an(a, l))
      return m;
    m.setOptions(u).then(function(y) {
      !p && u.onFirstUpdate && u.onFirstUpdate(y);
    });
    function C() {
      c.orderedModifiers.forEach(function(y) {
        var _ = y.name, w = y.options, M = w === void 0 ? {} : w, S = y.effect;
        if (typeof S == "function") {
          var L = S({
            state: c,
            name: _,
            instance: m,
            options: M
          }), V = function() {
          };
          f.push(L || V);
        }
      });
    }
    function b() {
      f.forEach(function(y) {
        return y();
      }), f = [];
    }
    return m;
  };
}
var Ys = [bs, Ps, ms, ss, Ts, Fs, js, ds, Vs], Gs = /* @__PURE__ */ Xs({
  defaultModifiers: Ys
}), Wt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function In(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ks = typeof Element < "u", Js = typeof Map == "function", Qs = typeof Set == "function", eo = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function zt(e, t) {
  if (e === t) return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor) return !1;
    var r, n, i;
    if (Array.isArray(e)) {
      if (r = e.length, r != t.length) return !1;
      for (n = r; n-- !== 0; )
        if (!zt(e[n], t[n])) return !1;
      return !0;
    }
    var s;
    if (Js && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size) return !1;
      for (s = e.entries(); !(n = s.next()).done; )
        if (!t.has(n.value[0])) return !1;
      for (s = e.entries(); !(n = s.next()).done; )
        if (!zt(n.value[1], t.get(n.value[0]))) return !1;
      return !0;
    }
    if (Qs && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size) return !1;
      for (s = e.entries(); !(n = s.next()).done; )
        if (!t.has(n.value[0])) return !1;
      return !0;
    }
    if (eo && ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (r = e.length, r != t.length) return !1;
      for (n = r; n-- !== 0; )
        if (e[n] !== t[n]) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof t.valueOf == "function") return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof t.toString == "function") return e.toString() === t.toString();
    if (i = Object.keys(e), r = i.length, r !== Object.keys(t).length) return !1;
    for (n = r; n-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, i[n])) return !1;
    if (Ks && e instanceof Element) return !1;
    for (n = r; n-- !== 0; )
      if (!((i[n] === "_owner" || i[n] === "__v" || i[n] === "__o") && e.$$typeof) && !zt(e[i[n]], t[i[n]]))
        return !1;
    return !0;
  }
  return e !== e && t !== t;
}
var to = function(t, r) {
  try {
    return zt(t, r);
  } catch (n) {
    if ((n.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw n;
  }
};
const ro = /* @__PURE__ */ In(to);
var no = [], io = function(t, r, n) {
  n === void 0 && (n = {});
  var i = Pe.useRef(null), s = {
    onFirstUpdate: n.onFirstUpdate,
    placement: n.placement || "bottom",
    strategy: n.strategy || "absolute",
    modifiers: n.modifiers || no
  }, o = Pe.useState({
    styles: {
      popper: {
        position: s.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), a = o[0], l = o[1], u = Pe.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(m) {
        var C = m.state, b = Object.keys(C.elements);
        Si.flushSync(function() {
          l({
            styles: Gr(b.map(function(y) {
              return [y, C.styles[y] || {}];
            })),
            attributes: Gr(b.map(function(y) {
              return [y, C.attributes[y]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), c = Pe.useMemo(function() {
    var p = {
      onFirstUpdate: s.onFirstUpdate,
      placement: s.placement,
      strategy: s.strategy,
      modifiers: [].concat(s.modifiers, [u, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return ro(i.current, p) ? i.current || p : (i.current = p, p);
  }, [s.onFirstUpdate, s.placement, s.strategy, s.modifiers, u]), f = Pe.useRef();
  return Kr(function() {
    f.current && f.current.setOptions(c);
  }, [c]), Kr(function() {
    if (!(t == null || r == null)) {
      var p = n.createPopper || Gs, m = p(t, r, c);
      return f.current = m, function() {
        m.destroy(), f.current = null;
      };
    }
  }, [t, r, n.createPopper]), {
    state: f.current ? f.current.state : null,
    styles: a.styles,
    attributes: a.attributes,
    update: f.current ? f.current.update : null,
    forceUpdate: f.current ? f.current.forceUpdate : null
  };
};
function or({ children: e, mounted: t = !1, rootClassName: r = "portal-root" }) {
  const [n, i] = oe(null);
  return ce(() => {
    if (!t) {
      i(null);
      return;
    }
    const s = document.createElement("div");
    s.className = r, i(s), document.body.appendChild(s);
    const o = () => {
      document.documentElement.classList.contains("dark") || document.body.classList.contains("dark") || document.documentElement.getAttribute("data-mode") === "dark" || document.body.getAttribute("data-mode") === "dark" ? (s.classList.add("dark"), s.setAttribute("data-mode", "dark")) : (s.classList.remove("dark"), s.setAttribute("data-mode", "light"));
    };
    o();
    const a = new MutationObserver(o);
    return a.observe(document.documentElement, {
      attributes: !0,
      attributeFilter: ["class", "data-mode"]
    }), a.observe(document.body, {
      attributes: !0,
      attributeFilter: ["class", "data-mode"]
    }), () => {
      a.disconnect(), document.body.removeChild(s);
    };
  }, [t]), n ? Ai(e, n) : null;
}
function so(e, t) {
  if (e === t)
    return !0;
  if (e.length !== t.length)
    return !1;
  for (let r = 0; r < e.length; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function oo(e) {
  const t = rt(e);
  return so(t.current, e) || (t.current = e), t.current;
}
function ao(e, t = () => null, { enabled: r = !0 } = {}) {
  const n = Array.isArray(e) ? e : [e], i = oo(n);
  ce(() => {
    function s(o) {
      r && i.every((a) => !(a != null && a.contains(o.target))) && t();
    }
    return document.addEventListener("mousedown", s), () => {
      document.removeEventListener("mousedown", s);
    };
  }, [i, r, t]);
}
function $n({
  open: e = !1,
  className: t,
  anchorEl: r,
  placement: n = "bottom-start",
  offset: i = [0, 0],
  children: s,
  style: o,
  onClickOutside: a
}) {
  const [l, u] = oe(null), { styles: c } = io(r, l, {
    placement: n,
    modifiers: [{ name: "offset", options: { offset: i } }]
  });
  return ao([l, r], a, { enabled: e }), /* @__PURE__ */ h(or, { mounted: e, children: /* @__PURE__ */ h("div", { ref: u, style: { ...c.popper, ...o }, className: F("bbn-popover", t), children: s }) });
}
function lo(e) {
  const [t, r] = oe({ width: 0, height: 0 });
  return ce(() => {
    if (!e) {
      r({ width: 0, height: 0 });
      return;
    }
    const n = new ResizeObserver(([i]) => {
      r({
        width: i.target.clientWidth,
        height: i.target.clientHeight
      });
    });
    return n.observe(e), () => {
      n.unobserve(e);
    };
  }, [e]), t;
}
const co = (e) => e.label, Hn = De(
  ({
    disabled: e,
    className: t,
    value: r,
    defaultValue: n,
    placeholder: i = "Select option",
    open: s,
    defaultOpen: o,
    options: a = [],
    optionClassName: l,
    popoverClassName: u,
    state: c = "default",
    onOpen: f,
    onSelect: p,
    onClose: m,
    renderSelectedOption: C = co,
    ...b
  }, y) => {
    const _ = rt(null);
    kn(y, () => _.current, []);
    const { width: w } = lo(_.current), [M, S] = ot({
      value: s,
      defaultValue: o,
      onStateChange: (R) => void (R ? f == null ? void 0 : f() : m == null ? void 0 : m())
    }), [L, V] = ot({
      value: r,
      defaultValue: n,
      onStateChange: p
    }), O = We(
      () => a.find((R) => R.value === L),
      [a, L]
    ), $ = le(
      (R) => {
        V(R.value), S(!1);
      },
      [V, S]
    ), j = le(() => {
      S(!1);
    }, [S]), H = le(() => {
      e || S(!M);
    }, [M, e, S]);
    return /* @__PURE__ */ E(Ft, { children: [
      /* @__PURE__ */ E(
        "div",
        {
          ref: _,
          className: F("bbn-select", e && "bbn-select-disabled", `bbn-select-${c}`, t),
          onClick: H,
          tabIndex: e ? -1 : 0,
          ...b,
          children: [
            /* @__PURE__ */ h("span", { children: O ? C(O) : i }),
            /* @__PURE__ */ h(Ui, { className: F("bbn-select-icon", M && "bbn-select-icon-open"), size: 20 })
          ]
        }
      ),
      /* @__PURE__ */ h(
        $n,
        {
          anchorEl: _.current,
          className: F("bbn-select-menu custom-scrollbar", u),
          open: M && !e,
          onClickOutside: j,
          offset: [0, 4],
          placement: "bottom-start",
          style: { width: w },
          children: a.map((R) => /* @__PURE__ */ h(
            "div",
            {
              className: F(
                "bbn-select-option",
                (O == null ? void 0 : O.value) === R.value && "bbn-select-option-selected",
                l
              ),
              onClick: () => $(R),
              children: R.label
            },
            R.value
          ))
        }
      )
    ] });
  }
);
Hn.displayName = "Select";
const Vr = De(
  ({ className: e, prefix: t, suffix: r, disabled: n = !1, state: i = "default", ...s }, o) => /* @__PURE__ */ E("div", { className: F("bbn-input", n && "bbn-input-disabled", `bbn-input-${i}`), children: [
    t && /* @__PURE__ */ h("div", { className: "bbn-input-prefix", children: t }),
    /* @__PURE__ */ h("input", { ref: o, className: F("bbn-input-field", e), disabled: n, ...s }),
    r && /* @__PURE__ */ h("div", { className: "bbn-input-suffix", children: r })
  ] })
);
Vr.displayName = "Input";
function ar({ children: e, label: t, hint: r, state: n = "default", className: i }) {
  return /* @__PURE__ */ E("div", { className: F("bbn-form-control", i), children: [
    t ? /* @__PURE__ */ E("label", { className: "bbn-form-control-label", children: [
      /* @__PURE__ */ h("div", { className: "bbn-form-control-title", children: t }),
      e
    ] }) : e,
    r && /* @__PURE__ */ h("div", { className: F("bbn-form-control-hint", `bbn-form-control-hint-${n}`), children: r })
  ] });
}
const Un = ir({
  removeDialog: () => null,
  updateDialog: () => null
});
function Qa({ children: e }) {
  const [t, r] = oe({}), n = We(() => Object.values(t).some((a) => a), [t]);
  ce(
    function() {
      if (n) {
        const l = document.body.offsetWidth;
        document.body.style.overflow = "hidden", document.body.style.paddingRight = document.body.offsetWidth - l >= 1 ? Cr(document.body.offsetWidth - l) ?? "" : document.body.style.paddingRight;
      } else
        document.body.style.overflow = "", document.body.style.paddingRight = "";
    },
    [n]
  );
  const i = le((a) => {
    r((l) => Reflect.deleteProperty(l, a) ? { ...l } : l);
  }, []), s = le((a, l) => {
    r((u) => ({ ...u, [a]: l }));
  }, []), o = We(() => ({ removeDialog: i, updateDialog: s }), [i, s]);
  return /* @__PURE__ */ h(Un.Provider, { value: o, children: e });
}
function Wn({ open: e = !1 } = {}) {
  const t = En(), [r, n] = oe(e), { updateDialog: i, removeDialog: s } = Lt(Un), o = e || r;
  ce(
    () => () => {
      s(t);
    },
    [t]
  ), ce(() => {
    i(t, o);
  }, [t, o, i]), ce(() => {
    e && n(!0);
  }, [e]);
  const a = le(() => {
    e || n(!1);
  }, [e]);
  return {
    mounted: r,
    unmount: a
  };
}
const qn = ({ open: e = !1, ...t }) => /* @__PURE__ */ h(
  "div",
  {
    ...t,
    className: F("bbn-backdrop", e ? "animate-backdrop-in" : "animate-backdrop-out", t.className)
  }
), uo = ({
  children: e,
  open: t = !1,
  className: r,
  onClose: n,
  hasBackdrop: i = !0,
  backdropClassName: s,
  dialogClassName: o,
  ...a
}) => {
  const { mounted: l, unmount: u } = Wn({ open: t });
  return /* @__PURE__ */ E(or, { mounted: l, children: [
    /* @__PURE__ */ h("div", { ...a, className: F("bbn-dialog-wrapper", r), children: /* @__PURE__ */ h(
      "div",
      {
        className: F("bbn-dialog", t ? "animate-modal-in" : "animate-modal-out", o),
        onAnimationEnd: u,
        children: e
      }
    ) }),
    i && /* @__PURE__ */ h(qn, { className: s, open: t, onClick: n })
  ] });
}, _r = ({
  children: e,
  className: t = "",
  size: r = 40,
  variant: n = "default",
  background: i = !1,
  rounded: s = !1
}) => {
  const o = {
    default: "text-accent-secondary",
    primary: "text-primary-light",
    secondary: "text-accent-secondary",
    error: "text-error-main",
    success: "text-success-main",
    "accent-primary": "text-accent-primary",
    "accent-secondary": "text-accent-secondary"
  };
  return /* @__PURE__ */ h(
    "div",
    {
      className: F(
        "flex items-center justify-center",
        i && {
          default: "bg-accent-secondary/10",
          primary: "bg-primary-light/10 dark:bg-[#47484A]",
          secondary: "bg-accent-secondary/10",
          error: "bg-error-main/10",
          success: "bg-success-main/10",
          "accent-primary": "bg-accent-primary/10",
          "accent-secondary": "bg-accent-secondary/10"
        }[n],
        s && "rounded-full",
        i ? "[&_svg]:w-4 [&_svg]:h-4" : "[&_svg]:w-full [&_svg]:h-full",
        "[&_svg_path]:fill-current",
        i && "dark:[&_svg_path]:fill-white",
        o[n],
        t
      ),
      style: { width: r, height: r },
      children: e
    }
  );
}, el = ({
  className: e = "",
  size: t = 24,
  variant: r = "primary"
}) => /* @__PURE__ */ h(_r, { variant: r, background: !0, rounded: !0, className: e, children: /* @__PURE__ */ h(
  "svg",
  {
    style: { width: t, height: t * 0.545 },
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ h("path", { d: "M20 4H11.65C10.83 1.67 8.61 0 6 0C2.69 0 0 2.69 0 6C0 9.31 2.69 12 6 12C8.61 12 10.83 10.33 11.65 8H12L14 10L16 8L18 10L22 5.96L20 4ZM6 9C4.35 9 3 7.65 3 6C3 4.35 4.35 3 6 3C7.65 3 9 4.35 9 6C9 7.65 7.65 9 6 9Z" })
  }
) }), tl = ({
  className: e = "",
  size: t = 24,
  variant: r = "primary"
}) => /* @__PURE__ */ h(_r, { variant: r, background: !0, rounded: !0, className: e, children: /* @__PURE__ */ h(
  "svg",
  {
    style: { width: t, height: t },
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ h("path", { d: "M15 0H11V2H15C16.65 2 18 3.35 18 5C18 6.65 16.65 8 15 8H11V10H15C17.76 10 20 7.76 20 5C20 2.24 17.76 0 15 0ZM9 8H5C3.35 8 2 6.65 2 5C2 3.35 3.35 2 5 2H9V0H5C2.24 0 0 2.24 0 5C0 7.76 2.24 10 5 10H9V8ZM6 4H14V6H6V4Z" })
  }
) }), rl = ({
  className: e = "",
  size: t = 24,
  variant: r = "primary"
}) => /* @__PURE__ */ h(_r, { variant: r, background: !0, rounded: !0, className: e, children: /* @__PURE__ */ E(
  "svg",
  {
    style: { width: t, height: t },
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ h("path", { d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z" }),
      /* @__PURE__ */ h("path", { d: "M10 15C12.7614 15 15 12.7614 15 10C15 7.23858 12.7614 5 10 5C7.23858 5 5 7.23858 5 10C5 12.7614 7.23858 15 10 15Z" })
    ]
  }
) }), nl = ({
  className: e = "",
  size: t = 16,
  variant: r = "default",
  color: n
}) => {
  const i = n || zn[r];
  return /* @__PURE__ */ h(
    "svg",
    {
      style: { width: t, height: t * 1.143 },
      viewBox: "0 0 14 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: F("transition-opacity duration-200", i, e),
      children: /* @__PURE__ */ h(
        "path",
        {
          d: "M9.99984 0.666626H1.99984C1.2665 0.666626 0.666504 1.26663 0.666504 1.99996V11.3333H1.99984V1.99996H9.99984V0.666626ZM11.9998 3.33329H4.6665C3.93317 3.33329 3.33317 3.93329 3.33317 4.66663V14C3.33317 14.7333 3.93317 15.3333 4.6665 15.3333H11.9998C12.7332 15.3333 13.3332 14.7333 13.3332 14V4.66663C13.3332 3.93329 12.7332 3.33329 11.9998 3.33329ZM11.9998 14H4.6665V4.66663H11.9998V14Z",
          fill: "currentColor"
        }
      )
    }
  );
}, fo = ({
  className: e = "",
  size: t = 14,
  variant: r = "default",
  color: n
}) => {
  const i = n || zn[r];
  return /* @__PURE__ */ h(
    "svg",
    {
      style: { width: t, height: t },
      viewBox: "0 0 14 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: F("transition-opacity duration-200", i, e),
      children: /* @__PURE__ */ h(
        "path",
        {
          d: "M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z",
          fill: "currentColor"
        }
      )
    }
  );
}, zn = {
  default: "text-accent-primary",
  primary: "text-primary-light",
  secondary: "text-accent-secondary",
  error: "text-error-main",
  success: "text-success-main",
  "accent-primary": "text-accent-primary",
  "accent-secondary": "text-accent-secondary"
}, Zn = ({ children: e, open: t = !1, className: r, onClose: n, ...i }) => {
  const { mounted: s, unmount: o } = Wn({ open: t });
  return /* @__PURE__ */ E(or, { mounted: s, children: [
    /* @__PURE__ */ E(
      "div",
      {
        ...i,
        className: F(
          "bbn-dialog-mobile",
          t ? "animate-mobile-modal-in" : "animate-mobile-modal-out",
          r
        ),
        onAnimationEnd: o,
        children: [
          n && /* @__PURE__ */ h(
            "button",
            {
              onClick: n,
              className: "absolute top-4 left-4 z-10 p-1.5 rounded-full bg-surface-tertiary hover:bg-surface-quaternary transition-colors",
              "aria-label": "Close",
              children: /* @__PURE__ */ h(fo, { size: 14, variant: "accent-primary" })
            }
          ),
          e
        ]
      }
    ),
    /* @__PURE__ */ h(qn, { open: t, onClick: n })
  ] });
}, ho = ({ className: e, children: t, title: r, onClose: n }) => /* @__PURE__ */ E("div", { className: F("bbn-dialog-header", e), children: [
  /* @__PURE__ */ E("div", { className: "bbn-dialog-title", children: [
    /* @__PURE__ */ h(Nr, { variant: "h5", children: r }),
    !!n && /* @__PURE__ */ h(Sn, { className: "shrink-0", onClick: n, children: /* @__PURE__ */ h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ h(
      "path",
      {
        d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
        fill: "currentColor"
      }
    ) }) })
  ] }),
  t
] }), po = (e) => /* @__PURE__ */ h("div", { ...e, className: F("bbn-dialog-body", e.className) }), vo = (e) => /* @__PURE__ */ h("div", { ...e, className: F("bbn-dialog-footer", e.className) });
function il({ className: e, ...t }) {
  return /* @__PURE__ */ h("span", { ...t, className: F("bbn-chip", e) });
}
function sl({ size: e = 40, className: t }) {
  return /* @__PURE__ */ h("span", { className: be("bbn-loader text-current", t), style: { width: e, height: e }, children: /* @__PURE__ */ h("svg", { viewBox: "22 22 44 44", children: /* @__PURE__ */ h("circle", { cx: "44", cy: "44", r: "20.2", fill: "none", stroke: "currentColor", strokeWidth: "3.6" }) }) });
}
var Xn = "Expected a function", ln = NaN, mo = "[object Symbol]", go = /^\s+|\s+$/g, bo = /^[-+]0x[0-9a-f]+$/i, yo = /^0b[01]+$/i, wo = /^0o[0-7]+$/i, xo = parseInt, Co = typeof Wt == "object" && Wt && Wt.Object === Object && Wt, No = typeof self == "object" && self && self.Object === Object && self, Oo = Co || No || Function("return this")(), ko = Object.prototype, Eo = ko.toString, So = Math.max, Ao = Math.min, fr = function() {
  return Oo.Date.now();
};
function Fo(e, t, r) {
  var n, i, s, o, a, l, u = 0, c = !1, f = !1, p = !0;
  if (typeof e != "function")
    throw new TypeError(Xn);
  t = cn(t) || 0, Jt(r) && (c = !!r.leading, f = "maxWait" in r, s = f ? So(cn(r.maxWait) || 0, t) : s, p = "trailing" in r ? !!r.trailing : p);
  function m(V) {
    var O = n, $ = i;
    return n = i = void 0, u = V, o = e.apply($, O), o;
  }
  function C(V) {
    return u = V, a = setTimeout(_, t), c ? m(V) : o;
  }
  function b(V) {
    var O = V - l, $ = V - u, j = t - O;
    return f ? Ao(j, s - $) : j;
  }
  function y(V) {
    var O = V - l, $ = V - u;
    return l === void 0 || O >= t || O < 0 || f && $ >= s;
  }
  function _() {
    var V = fr();
    if (y(V))
      return w(V);
    a = setTimeout(_, b(V));
  }
  function w(V) {
    return a = void 0, p && n ? m(V) : (n = i = void 0, o);
  }
  function M() {
    a !== void 0 && clearTimeout(a), u = 0, n = l = i = a = void 0;
  }
  function S() {
    return a === void 0 ? o : w(fr());
  }
  function L() {
    var V = fr(), O = y(V);
    if (n = arguments, i = this, l = V, O) {
      if (a === void 0)
        return C(l);
      if (f)
        return a = setTimeout(_, t), m(l);
    }
    return a === void 0 && (a = setTimeout(_, t)), o;
  }
  return L.cancel = M, L.flush = S, L;
}
function Lo(e, t, r) {
  var n = !0, i = !0;
  if (typeof e != "function")
    throw new TypeError(Xn);
  return Jt(r) && (n = "leading" in r ? !!r.leading : n, i = "trailing" in r ? !!r.trailing : i), Fo(e, t, {
    leading: n,
    maxWait: t,
    trailing: i
  });
}
function Jt(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
function Vo(e) {
  return !!e && typeof e == "object";
}
function _o(e) {
  return typeof e == "symbol" || Vo(e) && Eo.call(e) == mo;
}
function cn(e) {
  if (typeof e == "number")
    return e;
  if (_o(e))
    return ln;
  if (Jt(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Jt(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = e.replace(go, "");
  var r = yo.test(e);
  return r || wo.test(e) ? xo(e.slice(2), r ? 2 : 8) : bo.test(e) ? ln : +e;
}
var Do = Lo;
const Yn = /* @__PURE__ */ In(Do);
function To(e, { onLoadMore: t, hasMore: r = !1, loading: n = !1 } = {}) {
  const [i, s] = oe(!1);
  return ce(() => {
    const o = Yn((l) => {
      const u = l.target;
      s(u.scrollTop > 0), !n && r && u.scrollHeight - u.scrollTop <= u.clientHeight + 100 && (t == null || t());
    }, 100), a = e.current;
    if (a)
      return a.addEventListener("scroll", o), () => a.removeEventListener("scroll", o);
  }, [n, r, t, e]), {
    isScrolledTop: i
  };
}
const Gn = ir({
  data: [],
  columns: [],
  sortStates: {},
  onColumnSort: void 0,
  onRowSelect: void 0
});
function Mo({
  name: e,
  className: t,
  children: r,
  sorter: n,
  ...i
}) {
  const { columns: s, sortStates: o, onColumnSort: a } = Lt(Gn), l = o[e ?? ""], u = l == null ? void 0 : l.direction;
  return /* @__PURE__ */ h(
    X,
    {
      variant: "caption",
      as: "th",
      className: F("bbn-cell-left", n && "bbn-table-sortable", t),
      onClick: () => {
        if (n && e) {
          const c = s.find((f) => f.key === e);
          a == null || a(e, c == null ? void 0 : c.sorter);
        }
      },
      "data-column": e,
      ...i,
      children: /* @__PURE__ */ E("div", { className: "flex items-center justify-between gap-1", children: [
        /* @__PURE__ */ h("span", { children: r }),
        n && /* @__PURE__ */ E("span", { className: "bbn-table-sort-icons", children: [
          /* @__PURE__ */ h(
            Wi,
            {
              className: F(
                "bbn-sort-icon bbn-sort-icon-up",
                u === "asc" ? "bbn-sort-icon-active" : "bbn-sort-icon-inactive"
              )
            }
          ),
          /* @__PURE__ */ h(
            Hi,
            {
              className: F(
                "bbn-sort-icon bbn-sort-icon-down",
                u === "desc" ? "bbn-sort-icon-active" : "bbn-sort-icon-inactive"
              )
            }
          )
        ] })
      ] })
    }
  );
}
function Po(e, t) {
  const [r, n] = oe({}), i = le((o, a) => {
    a && n((l) => {
      var p;
      const u = ((p = l[o]) == null ? void 0 : p.direction) ?? null, c = u === null ? "asc" : u === "asc" ? "desc" : null;
      if (c === null)
        return Object.fromEntries(
          Object.entries(l).filter(([m]) => m !== o).map(([m, C]) => [
            m,
            { ...C, priority: C.priority > l[o].priority ? C.priority - 1 : C.priority }
          ])
        );
      const f = Math.max(0, ...Object.values(l).map((m) => m.priority));
      return {
        ...l,
        [o]: { direction: c, priority: f + 1 }
      };
    });
  }, []), s = We(() => {
    const o = Object.entries(r).filter(([, a]) => a.direction !== null).toSorted((a, l) => l[1].priority - a[1].priority).map(([a, l]) => ({
      column: t.find((u) => u.key === a),
      direction: l.direction
    })).filter(({ column: a }) => a == null ? void 0 : a.sorter);
    return o.length === 0 ? e : e.toSorted((a, l) => {
      for (const { column: u, direction: c } of o) {
        const f = u.sorter(a, l);
        if (f !== 0) return c === "asc" ? f : -f;
      }
      return 0;
    });
  }, [e, t, r]);
  return { sortStates: r, handleColumnSort: i, sortedData: s };
}
function Ro({
  className: e,
  render: t,
  value: r,
  columnName: n,
  ...i
}) {
  return /* @__PURE__ */ h(
    X,
    {
      variant: "body2",
      as: "td",
      className: F("bbn-cell-left", e),
      "data-column": n,
      ...i,
      children: t ? t(r) : r
    }
  );
}
function Bo({
  row: e,
  columns: t,
  isSelected: r,
  isSelectable: n,
  onSelect: i
}) {
  return /* @__PURE__ */ h(
    "tr",
    {
      className: F(
        r && "selected",
        !!i && n && "cursor-pointer",
        !n && "opacity-50"
      ),
      onClick: () => i(e),
      children: t.map((s) => /* @__PURE__ */ h(
        Ro,
        {
          value: e[s.key],
          columnName: s.key,
          className: s.cellClassName,
          render: s.render ? (o) => s.render(o, e) : void 0
        },
        s.key
      ))
    }
  );
}
function jo({
  data: e,
  columns: t,
  className: r,
  wrapperClassName: n,
  hasMore: i = !1,
  loading: s = !1,
  onLoadMore: o,
  onRowSelect: a,
  isRowSelectable: l,
  selectedRow: u,
  defaultSelectedRow: c,
  onSelectedRowChange: f,
  ...p
}, m) {
  const C = rt(null);
  kn(m, () => C.current, []);
  const { sortStates: b, handleColumnSort: y, sortedData: _ } = Po(e, t), { isScrolledTop: w } = To(C, { onLoadMore: o, hasMore: i, loading: s }), [M, S] = ot({
    value: u,
    defaultValue: c ?? null,
    onStateChange: f
  }), L = le(
    (O) => {
      if (!a || l && !l(O)) return;
      const $ = M === O.id ? null : O.id;
      S($), a($ === null ? null : O);
    },
    [a, l, M, S]
  ), V = We(
    () => ({
      data: _,
      columns: t,
      sortStates: b,
      onColumnSort: y,
      onRowSelect: L
    }),
    [_, t, b, y, L]
  );
  return /* @__PURE__ */ h(Gn.Provider, { value: V, children: /* @__PURE__ */ h("div", { ref: C, className: F("bbn-table-wrapper", n), children: /* @__PURE__ */ E("table", { className: F("bbn-table", r), ...p, children: [
    /* @__PURE__ */ h("thead", { className: F("bbn-table-header", w && "scrolled-top"), children: /* @__PURE__ */ h("tr", { children: t.map((O) => /* @__PURE__ */ h(Mo, { className: O.headerClassName, name: O.key, sorter: O.sorter, children: O.header }, O.key)) }) }),
    /* @__PURE__ */ h("tbody", { className: "bbn-table-body", children: _.map((O) => /* @__PURE__ */ h(
      Bo,
      {
        row: O,
        columns: t,
        isSelected: M === O.id,
        isSelectable: l ? l(O) : !0,
        onSelect: L
      },
      O.id
    )) })
  ] }) }) });
}
const ol = De(jo);
function Io({ as: e = "div", className: t, children: r }) {
  return br(e, { className: F("bbn-card", t) }, r);
}
function al(e) {
  const [t = !1, r] = ot({
    value: e.value,
    defaultValue: e.defaultValue,
    onStateChange: e.onChange
  });
  return /* @__PURE__ */ E("div", { className: "bbn-toggle", onClick: () => void r(!t), children: [
    /* @__PURE__ */ h("span", { className: "bbn-toggle-bg", children: e.activeIcon }),
    /* @__PURE__ */ h("span", { className: F("bbn-toggle-control", t && "bbn-toggle-control-active") }),
    /* @__PURE__ */ h("span", { className: "bbn-toggle-bg", children: e.inactiveIcon })
  ] });
}
const $o = {
  adaptive: "adaptive",
  horizontal: "vertical",
  vertical: "horizontal"
};
function ll({ className: e, orientation: t = "vertical", children: r }) {
  return /* @__PURE__ */ h("div", { className: be("bbn-list", `bbn-list-${t}`, e), children: Xt.map(
    r,
    (n) => wr(n) ? yr(n, {
      orientation: $o[t]
    }) : n
  ) });
}
function cl({ className: e, orientation: t = "horizontal", title: r, value: n, suffix: i }) {
  return /* @__PURE__ */ E("div", { className: F("bbn-list-item", `bbn-list-item-${t}`, e), children: [
    /* @__PURE__ */ h(
      X,
      {
        as: "div",
        className: F("bbn-list-title", `bbn-list-title-${t}`),
        variant: t === "horizontal" ? "body1" : "body2",
        children: r
      }
    ),
    /* @__PURE__ */ E(X, { as: "div", className: F("bbn-list-value", `bbn-list-value-${t}`), variant: "body1", children: [
      n,
      i
    ] })
  ] });
}
function ul({
  children: e,
  count: t = 0,
  max: r = 99,
  position: n = "bottom-right",
  color: i = "error",
  className: s,
  badgeClassName: o,
  contentClassName: a
}) {
  const l = typeof t == "number" ? t > 0 : t != null, u = typeof t == "number" && t > r ? `${r}+` : t, c = `bbn-badge-${n}`, f = `bbn-badge-${i}`;
  return /* @__PURE__ */ E("div", { className: F("bbn-badge", s), children: [
    e,
    l && /* @__PURE__ */ h("span", { className: F("bbn-badge-indicator", c, f, o), children: /* @__PURE__ */ h("span", { className: F("bbn-badge-content", a), children: u }) })
  ] });
}
const Dr = ({
  children: e,
  style: t,
  className: r
}) => /* @__PURE__ */ h("div", { className: F("flex rounded bg-secondary-highlight p-4 text-accent-primary", r), style: t, children: e });
function Ho(e) {
  return Vt({ attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8Z" }, child: [] }, { tag: "path", attr: { d: "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8Z" }, child: [] }] })(e);
}
function Uo({ counter: e, max: t, onAdd: r, alwaysShowCounter: n = !1 }) {
  const i = e < t, s = 0 < e || n && e === 0;
  return /* @__PURE__ */ E(
    "div",
    {
      className: F(
        "bg-primary-highlight flex overflow-hidden rounded-md border border-accent-primary w-fit",
        i && "cursor-pointer",
        !s && !i && "hidden",
        !s && "w-10"
      ),
      onClick: i ? r : void 0,
      children: [
        i && /* @__PURE__ */ h("div", { className: "flex h-10 w-10 items-center justify-center", children: /* @__PURE__ */ h(Ho, { size: 20 }) }),
        s && /* @__PURE__ */ E("div", { className: F(
          "flex h-10 items-center px-2 text-sm sm:px-4 sm:text-base",
          i && "border-l border-accent-primary"
        ), children: [
          e,
          "/",
          t
        ] })
      ]
    }
  );
}
const Kn = ir(void 0), Jn = () => Lt(Kn), Wo = ({ children: e, value: t }) => /* @__PURE__ */ h(Kn.Provider, { value: t, children: e }), Qn = ({
  isOpen: e,
  onClose: t,
  title: r,
  children: n,
  className: i = "",
  titleAlign: s = "left",
  backIcon: o,
  fullHeight: a = !1,
  fullWidth: l = !1,
  showBackButton: u = !0,
  showDivider: c = !0,
  onBackdropClick: f
}) => {
  const p = {
    left: "text-left",
    center: "text-center",
    right: "text-right"
  }, m = () => u || r ? /* @__PURE__ */ E(
    "div",
    {
      className: F(
        "flex items-center p-4",
        c && "border-b border-[#38708533] dark:border-[#404040]"
      ),
      children: [
        u && /* @__PURE__ */ h(
          "button",
          {
            onClick: t,
            className: "flex h-8 w-8 flex-shrink-0 items-center justify-center rounded transition-colors hover:bg-accent-secondary/10",
            "aria-label": "Go back",
            children: o || /* @__PURE__ */ h(
              "svg",
              {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "text-accent-primary",
                children: /* @__PURE__ */ h(
                  "path",
                  {
                    d: "M10 12L6 8L10 4",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  }
                )
              }
            )
          }
        ),
        r && /* @__PURE__ */ h(
          "h3",
          {
            className: F(
              "flex-1 text-sm font-medium text-accent-primary",
              u ? "ml-3" : "",
              p[s]
            ),
            children: r
          }
        )
      ]
    }
  ) : null, C = () => /* @__PURE__ */ E(Ft, { children: [
    m(),
    /* @__PURE__ */ h("div", { className: "flex-1 overflow-y-auto", children: n })
  ] });
  return a ? /* @__PURE__ */ E(or, { mounted: !0, rootClassName: "menu-drawer-portal", children: [
    f && /* @__PURE__ */ h(
      "div",
      {
        className: F(
          "fixed inset-0 z-40 bg-black/50 transition-opacity duration-300",
          e ? "opacity-100" : "pointer-events-none opacity-0"
        ),
        onClick: f
      }
    ),
    /* @__PURE__ */ h(
      "div",
      {
        className: F(
          "transform transition-transform duration-300 ease-in-out",
          "bg-[#FFFFFF] dark:bg-[#252525]",
          "fixed inset-y-0 right-0 z-50",
          l ? "w-full" : "w-full max-w-sm",
          e ? "translate-x-0" : "translate-x-full",
          i
        ),
        children: C()
      }
    )
  ] }) : /* @__PURE__ */ h(
    "div",
    {
      className: F(
        "transform transition-transform duration-300 ease-in-out",
        "bg-[#FFFFFF] dark:bg-[#252525]",
        "absolute inset-0 rounded-lg",
        e ? "translate-x-0" : "translate-x-full",
        i
      ),
      children: C()
    }
  );
};
function ei(e = 768, t = 100) {
  const [r, n] = oe(() => typeof window < "u" ? window.innerWidth < e : !1), i = rt(), s = le(() => {
    n(window.innerWidth < e);
  }, [e]);
  return ce(() => (i.current = Yn(s, t), s(), window.addEventListener("resize", i.current), () => {
    i.current && (window.removeEventListener("resize", i.current), i.current.cancel());
  }), [s, t]), r;
}
const qo = ({
  children: e,
  trigger: t,
  open: r,
  onOpenChange: n,
  placement: i = "bottom-end",
  offset: s = [0, 8],
  className: o,
  mobileMode: a = "dialog"
}) => {
  const [l, u] = oe(!1), c = rt(null), f = ei(), p = r !== void 0 ? r : l, m = (_) => {
    r === void 0 && u(_), n == null || n(_);
  }, C = () => m(!1), b = /* @__PURE__ */ h("div", { className: "relative w-full overflow-hidden", children: e }), y = t || /* @__PURE__ */ h("button", { className: "rounded p-2 hover:bg-gray-100 dark:hover:bg-gray-800", onClick: () => m(!p), children: "Menu" });
  return /* @__PURE__ */ E(Wo, { value: { isOpen: p, setIsOpen: m, onClose: C, isMobile: f }, children: [
    /* @__PURE__ */ h("div", { ref: c, className: "inline-block", children: B.isValidElement(y) && B.cloneElement(y, {
      onClick: () => m(!p),
      "aria-haspopup": "true",
      "aria-expanded": p
    }) }),
    f ? a === "dialog" ? /* @__PURE__ */ h(
      Zn,
      {
        open: p,
        onClose: C,
        className: F(
          "relative bg-[#FFFFFF] dark:bg-[#252525] text-primary-main",
          o
        ),
        children: b
      }
    ) : /* @__PURE__ */ h(
      Qn,
      {
        isOpen: p,
        onClose: C,
        onBackdropClick: C,
        fullHeight: !0,
        fullWidth: !0,
        showBackButton: !0,
        showDivider: !1,
        children: b
      }
    ) : /* @__PURE__ */ h(
      $n,
      {
        anchorEl: c.current,
        open: p,
        offset: s,
        placement: i,
        onClickOutside: C,
        className: F(
          "rounded-lg border border-[#38708533] bg-[#FFFFFF] shadow-lg dark:border-[#404040] dark:bg-[#252525]",
          "min-w-[294px]",
          o
        ),
        children: b
      }
    )
  ] });
}, zo = ({
  icon: e,
  name: t,
  description: r,
  onClick: n,
  disabled: i = !1,
  className: s,
  children: o,
  suffix: a,
  selected: l = !1,
  role: u = "menuitem"
}) => {
  const c = Jn(), f = () => {
    i || !n || (n(), c && !a && c.onClose());
  };
  return o ? /* @__PURE__ */ h(
    "button",
    {
      onClick: f,
      disabled: i,
      className: F("w-full text-left", i && "cursor-not-allowed opacity-50", s),
      children: o
    }
  ) : /* @__PURE__ */ E(
    "button",
    {
      onClick: f,
      disabled: i,
      className: F(
        "flex w-full items-center justify-between p-6",
        "transition-colors hover:bg-accent-secondary/5",
        "text-left",
        "focus:outline-none",
        l && "bg-accent-secondary/10",
        i && "cursor-not-allowed opacity-50",
        s
      ),
      role: u,
      "aria-selected": l,
      tabIndex: i ? -1 : 0,
      children: [
        /* @__PURE__ */ E("div", { className: "flex items-center gap-3", children: [
          e && /* @__PURE__ */ h("div", { className: "flex-shrink-0", children: e }),
          /* @__PURE__ */ E("div", { className: "flex flex-col", children: [
            /* @__PURE__ */ h("div", { className: "text-sm font-medium text-accent-primary", children: t }),
            r && /* @__PURE__ */ h("div", { className: "text-xs text-accent-secondary", children: r })
          ] })
        ] }),
        a
      ]
    }
  );
}, Zo = ({
  children: e,
  name: t,
  description: r,
  icon: n,
  backIcon: i,
  suffix: s,
  className: o,
  contentClassName: a,
  titleAlign: l = "left"
}) => {
  const [u, c] = oe(!1), f = Jn(), p = /* @__PURE__ */ h(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: "text-accent-primary",
      children: /* @__PURE__ */ h("path", { d: "M10 12L6 8L10 4", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
    }
  ), m = /* @__PURE__ */ h(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: "text-accent-primary",
      children: /* @__PURE__ */ h("path", { d: "M6 4L10 8L6 12", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
    }
  );
  return /* @__PURE__ */ E(Ft, { children: [
    /* @__PURE__ */ E(
      "button",
      {
        onClick: () => c(!0),
        className: F(
          "flex w-full items-center justify-between p-6",
          "transition-colors hover:bg-accent-secondary/5",
          "text-left focus:outline-none",
          o
        ),
        role: "menuitem",
        children: [
          /* @__PURE__ */ E("div", { className: "flex items-center gap-3", children: [
            n && /* @__PURE__ */ h("div", { className: "flex-shrink-0", children: n }),
            /* @__PURE__ */ E("div", { className: "flex flex-col", children: [
              /* @__PURE__ */ h("span", { className: "text-sm font-medium text-accent-primary", children: t }),
              r && /* @__PURE__ */ h("span", { className: "mt-0.5 text-xs text-accent-secondary", children: r })
            ] })
          ] }),
          s || m
        ]
      }
    ),
    /* @__PURE__ */ h(
      Qn,
      {
        isOpen: u,
        onClose: () => c(!1),
        title: t || "",
        titleAlign: l,
        backIcon: i || p,
        fullHeight: f == null ? void 0 : f.isMobile,
        fullWidth: f == null ? void 0 : f.isMobile,
        onBackdropClick: f != null && f.isMobile ? void 0 : () => c(!1),
        className: F(f != null && f.isMobile ? "z-60" : "z-50", a),
        children: e
      }
    )
  ] });
}, fl = ({
  label: e,
  description: t,
  onClick: r,
  selected: n = !1,
  className: i,
  suffix: s,
  disabled: o = !1
}) => {
  const a = /* @__PURE__ */ h("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h(
    "path",
    {
      d: "M16.6667 5L7.5 14.1667L3.33333 10",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ) });
  return /* @__PURE__ */ E(
    "button",
    {
      role: "menuitem",
      onClick: r,
      disabled: o,
      className: F(
        "flex w-full items-center justify-between p-4",
        "transition-colors hover:bg-accent-secondary/5",
        "text-left focus:outline-none",
        n && "bg-accent-secondary/10",
        o && "cursor-not-allowed opacity-50",
        i
      ),
      "aria-selected": n,
      tabIndex: o ? -1 : 0,
      children: [
        /* @__PURE__ */ E("div", { className: "flex flex-col items-start", children: [
          /* @__PURE__ */ h("span", { className: "font-medium text-accent-primary", children: e }),
          t && /* @__PURE__ */ h("span", { className: "text-sm text-accent-secondary", children: t })
        ] }),
        n && (s || a)
      ]
    }
  );
};
function Xo(e, t = 8) {
  if (!e || e.length <= t * 2)
    return e;
  const r = e.slice(0, t), n = e.slice(-t);
  return `${r}...${n}`;
}
const dl = ({
  value: e,
  symbols: t = 8,
  size: r = "body2",
  className: n
}) => e ? /* @__PURE__ */ h(X, { variant: r, className: F("text-accent-primary", n), children: /* @__PURE__ */ h("span", { children: Xo(e, t) ?? e }) }) : null;
function Yo(e = {}) {
  const { copiedText: t = "Copied ✓", timeout: r = 2e3 } = e, [n, i] = oe({}), [s, o] = oe({}), a = le(
    (f, p) => {
      !f || !p || (navigator.clipboard.writeText(p), i((m) => ({ ...m, [f]: !0 })), o((m) => ({ ...m, [f]: t })));
    },
    [t]
  ), l = le((f) => {
    f && (i((p) => ({ ...p, [f]: !1 })), o((p) => ({ ...p, [f]: "" })));
  }, []), u = le(
    (f) => f && n[f] || !1,
    [n]
  ), c = le(
    (f) => f && s[f] || "",
    [s]
  );
  return ce(() => {
    const f = {};
    return Object.entries(n).forEach(([p, m]) => {
      m && (f[p] = setTimeout(() => {
        l(p);
      }, r));
    }), () => {
      Object.values(f).forEach((p) => clearTimeout(p));
    };
  }, [n, r, l]), {
    isCopied: u,
    copiedText: c,
    copyToClipboard: a
  };
}
const hl = ({
  children: e,
  value: t,
  className: r,
  onCopy: n,
  isCopied: i,
  copiedText: s,
  timeout: o = 2e3
}) => {
  const a = En(), l = {
    copiedText: s,
    timeout: o
  }, {
    isCopied: u,
    copiedText: c,
    copyToClipboard: f
  } = Yo(l), p = i !== void 0, m = p ? i : u(a), C = p ? s || "Copied ✓" : c(a), b = (y) => {
    y.stopPropagation(), p && n ? n(t) : f(a, t);
  };
  return /* @__PURE__ */ h(
    "div",
    {
      className: be(
        "inline-flex items-center cursor-pointer hover:opacity-100 transition-opacity duration-200",
        r
      ),
      onClick: b,
      children: /* @__PURE__ */ E("div", { className: "relative", children: [
        /* @__PURE__ */ h(
          "div",
          {
            className: be(
              "transition-opacity duration-300 ease-in-out",
              m && "opacity-0"
            ),
            children: e
          }
        ),
        m && /* @__PURE__ */ h(
          "div",
          {
            className: be(
              "absolute inset-0 flex items-center transition-opacity duration-300 ease-in-out text-green-600",
              "opacity-100"
            ),
            children: C
          }
        )
      ] })
    }
  );
};
var Tt = (e) => e.type === "checkbox", Ke = (e) => e instanceof Date, ae = (e) => e == null;
const ti = (e) => typeof e == "object";
var te = (e) => !ae(e) && !Array.isArray(e) && ti(e) && !Ke(e), ri = (e) => te(e) && e.target ? Tt(e.target) ? e.target.checked : e.target.value : e, Go = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, ni = (e, t) => e.has(Go(t)), Ko = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return te(t) && t.hasOwnProperty("isPrototypeOf");
}, Tr = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function ie(e) {
  let t;
  const r = Array.isArray(e), n = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    t = new Date(e);
  else if (!(Tr && (e instanceof Blob || n)) && (r || te(e)))
    if (t = r ? [] : {}, !r && !Ko(e))
      t = e;
    else
      for (const i in e)
        e.hasOwnProperty(i) && (t[i] = ie(e[i]));
  else
    return e;
  return t;
}
var lr = (e) => /^\w*$/.test(e), ee = (e) => e === void 0, Mr = (e) => Array.isArray(e) ? e.filter(Boolean) : [], Pr = (e) => Mr(e.replace(/["|']|\]/g, "").split(/\.|\[/)), k = (e, t, r) => {
  if (!t || !te(e))
    return r;
  const n = (lr(t) ? [t] : Pr(t)).reduce((i, s) => ae(i) ? i : i[s], e);
  return ee(n) || n === e ? ee(e[t]) ? r : e[t] : n;
}, pe = (e) => typeof e == "boolean", z = (e, t, r) => {
  let n = -1;
  const i = lr(t) ? [t] : Pr(t), s = i.length, o = s - 1;
  for (; ++n < s; ) {
    const a = i[n];
    let l = r;
    if (n !== o) {
      const u = e[a];
      l = te(u) || Array.isArray(u) ? u : isNaN(+i[n + 1]) ? {} : [];
    }
    if (a === "__proto__" || a === "constructor" || a === "prototype")
      return;
    e[a] = l, e = e[a];
  }
};
const Qt = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Oe = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Me = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Rr = B.createContext(null);
Rr.displayName = "HookFormContext";
const dt = () => B.useContext(Rr), Jo = (e) => {
  const { children: t, ...r } = e;
  return B.createElement(Rr.Provider, { value: r }, t);
};
var ii = (e, t, r, n = !0) => {
  const i = {
    defaultValues: t._defaultValues
  };
  for (const s in e)
    Object.defineProperty(i, s, {
      get: () => {
        const o = s;
        return t._proxyFormState[o] !== Oe.all && (t._proxyFormState[o] = !n || Oe.all), r && (r[o] = !0), e[o];
      }
    });
  return i;
};
const Br = typeof window < "u" ? Pe.useLayoutEffect : Pe.useEffect;
function si(e) {
  const t = dt(), { control: r = t.control, disabled: n, name: i, exact: s } = e || {}, [o, a] = B.useState(r._formState), l = B.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  });
  return Br(() => r._subscribe({
    name: i,
    formState: l.current,
    exact: s,
    callback: (u) => {
      !n && a({
        ...r._formState,
        ...u
      });
    }
  }), [i, n, s]), B.useEffect(() => {
    l.current.isValid && r._setValid(!0);
  }, [r]), B.useMemo(() => ii(o, r, l.current, !1), [o, r]);
}
var Ae = (e) => typeof e == "string", oi = (e, t, r, n, i) => Ae(e) ? (n && t.watch.add(e), k(r, e, i)) : Array.isArray(e) ? e.map((s) => (n && t.watch.add(s), k(r, s))) : (n && (t.watchAll = !0), r);
function ai(e) {
  const t = dt(), { control: r = t.control, name: n, defaultValue: i, disabled: s, exact: o } = e || {}, a = B.useRef(i), [l, u] = B.useState(r._getWatch(n, a.current));
  return Br(() => r._subscribe({
    name: n,
    formState: {
      values: !0
    },
    exact: o,
    callback: (c) => !s && u(oi(n, r._names, c.values || r._formValues, !1, a.current))
  }), [n, r, s, o]), B.useEffect(() => r._removeUnmounted()), l;
}
function Qo(e) {
  const t = dt(), { name: r, disabled: n, control: i = t.control, shouldUnregister: s } = e, o = ni(i._names.array, r), a = ai({
    control: i,
    name: r,
    defaultValue: k(i._formValues, r, k(i._defaultValues, r, e.defaultValue)),
    exact: !0
  }), l = si({
    control: i,
    name: r,
    exact: !0
  }), u = B.useRef(e), c = B.useRef(i.register(r, {
    ...e.rules,
    value: a,
    ...pe(e.disabled) ? { disabled: e.disabled } : {}
  })), f = B.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!k(l.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!k(l.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!k(l.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!k(l.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => k(l.errors, r)
    }
  }), [l, r]), p = B.useCallback((y) => c.current.onChange({
    target: {
      value: ri(y),
      name: r
    },
    type: Qt.CHANGE
  }), [r]), m = B.useCallback(() => c.current.onBlur({
    target: {
      value: k(i._formValues, r),
      name: r
    },
    type: Qt.BLUR
  }), [r, i._formValues]), C = B.useCallback((y) => {
    const _ = k(i._fields, r);
    _ && y && (_._f.ref = {
      focus: () => y.focus && y.focus(),
      select: () => y.select && y.select(),
      setCustomValidity: (w) => y.setCustomValidity(w),
      reportValidity: () => y.reportValidity()
    });
  }, [i._fields, r]), b = B.useMemo(() => ({
    name: r,
    value: a,
    ...pe(n) || l.disabled ? { disabled: l.disabled || n } : {},
    onChange: p,
    onBlur: m,
    ref: C
  }), [r, n, l.disabled, p, m, C, a]);
  return B.useEffect(() => {
    const y = i._options.shouldUnregister || s;
    i.register(r, {
      ...u.current.rules,
      ...pe(u.current.disabled) ? { disabled: u.current.disabled } : {}
    });
    const _ = (w, M) => {
      const S = k(i._fields, w);
      S && S._f && (S._f.mount = M);
    };
    if (_(r, !0), y) {
      const w = ie(k(i._options.defaultValues, r));
      z(i._defaultValues, r, w), ee(k(i._formValues, r)) && z(i._formValues, r, w);
    }
    return !o && i.register(r), () => {
      (o ? y && !i._state.action : y) ? i.unregister(r) : _(r, !1);
    };
  }, [r, i, o, s]), B.useEffect(() => {
    i._setDisabledField({
      disabled: n,
      name: r
    });
  }, [n, r, i]), B.useMemo(() => ({
    field: b,
    formState: l,
    fieldState: f
  }), [b, l, f]);
}
var li = (e, t, r, n, i) => t ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [n]: i || !0
  }
} : {}, Nt = (e) => Array.isArray(e) ? e : [e], un = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (i) => {
      for (const s of e)
        s.next && s.next(i);
    },
    subscribe: (i) => (e.push(i), {
      unsubscribe: () => {
        e = e.filter((s) => s !== i);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, gr = (e) => ae(e) || !ti(e);
function Ue(e, t, r = /* @__PURE__ */ new WeakSet()) {
  if (gr(e) || gr(t))
    return e === t;
  if (Ke(e) && Ke(t))
    return e.getTime() === t.getTime();
  const n = Object.keys(e), i = Object.keys(t);
  if (n.length !== i.length)
    return !1;
  if (r.has(e) || r.has(t))
    return !0;
  r.add(e), r.add(t);
  for (const s of n) {
    const o = e[s];
    if (!i.includes(s))
      return !1;
    if (s !== "ref") {
      const a = t[s];
      if (Ke(o) && Ke(a) || te(o) && te(a) || Array.isArray(o) && Array.isArray(a) ? !Ue(o, a, r) : o !== a)
        return !1;
    }
  }
  return !0;
}
var fe = (e) => te(e) && !Object.keys(e).length, jr = (e) => e.type === "file", ke = (e) => typeof e == "function", er = (e) => {
  if (!Tr)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, ci = (e) => e.type === "select-multiple", Ir = (e) => e.type === "radio", ea = (e) => Ir(e) || Tt(e), dr = (e) => er(e) && e.isConnected;
function ta(e, t) {
  const r = t.slice(0, -1).length;
  let n = 0;
  for (; n < r; )
    e = ee(e) ? n++ : e[t[n++]];
  return e;
}
function ra(e) {
  for (const t in e)
    if (e.hasOwnProperty(t) && !ee(e[t]))
      return !1;
  return !0;
}
function re(e, t) {
  const r = Array.isArray(t) ? t : lr(t) ? [t] : Pr(t), n = r.length === 1 ? e : ta(e, r), i = r.length - 1, s = r[i];
  return n && delete n[s], i !== 0 && (te(n) && fe(n) || Array.isArray(n) && ra(n)) && re(e, r.slice(0, -1)), e;
}
var ui = (e) => {
  for (const t in e)
    if (ke(e[t]))
      return !0;
  return !1;
};
function tr(e, t = {}) {
  const r = Array.isArray(e);
  if (te(e) || r)
    for (const n in e)
      Array.isArray(e[n]) || te(e[n]) && !ui(e[n]) ? (t[n] = Array.isArray(e[n]) ? [] : {}, tr(e[n], t[n])) : ae(e[n]) || (t[n] = !0);
  return t;
}
function fi(e, t, r) {
  const n = Array.isArray(e);
  if (te(e) || n)
    for (const i in e)
      Array.isArray(e[i]) || te(e[i]) && !ui(e[i]) ? ee(t) || gr(r[i]) ? r[i] = Array.isArray(e[i]) ? tr(e[i], []) : { ...tr(e[i]) } : fi(e[i], ae(t) ? {} : t[i], r[i]) : r[i] = !Ue(e[i], t[i]);
  return r;
}
var yt = (e, t) => fi(e, t, tr(t));
const fn = {
  value: !1,
  isValid: !1
}, dn = { value: !0, isValid: !0 };
var di = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ee(e[0].attributes.value) ? ee(e[0].value) || e[0].value === "" ? dn : { value: e[0].value, isValid: !0 } : dn
    ) : fn;
  }
  return fn;
}, hi = (e, { valueAsNumber: t, valueAsDate: r, setValueAs: n }) => ee(e) ? e : t ? e === "" ? NaN : e && +e : r && Ae(e) ? new Date(e) : n ? n(e) : e;
const hn = {
  isValid: !1,
  value: null
};
var pi = (e) => Array.isArray(e) ? e.reduce((t, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : t, hn) : hn;
function pn(e) {
  const t = e.ref;
  return jr(t) ? t.files : Ir(t) ? pi(e.refs).value : ci(t) ? [...t.selectedOptions].map(({ value: r }) => r) : Tt(t) ? di(e.refs).value : hi(ee(t.value) ? e.ref.value : t.value, e);
}
var na = (e, t, r, n) => {
  const i = {};
  for (const s of e) {
    const o = k(t, s);
    o && z(i, s, o._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: i,
    shouldUseNativeValidation: n
  };
}, rr = (e) => e instanceof RegExp, wt = (e) => ee(e) ? e : rr(e) ? e.source : te(e) ? rr(e.value) ? e.value.source : e.value : e, vn = (e) => ({
  isOnSubmit: !e || e === Oe.onSubmit,
  isOnBlur: e === Oe.onBlur,
  isOnChange: e === Oe.onChange,
  isOnAll: e === Oe.all,
  isOnTouch: e === Oe.onTouched
});
const mn = "AsyncFunction";
var ia = (e) => !!e && !!e.validate && !!(ke(e.validate) && e.validate.constructor.name === mn || te(e.validate) && Object.values(e.validate).find((t) => t.constructor.name === mn)), sa = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), gn = (e, t, r) => !r && (t.watchAll || t.watch.has(e) || [...t.watch].some((n) => e.startsWith(n) && /^\.\w+/.test(e.slice(n.length))));
const Ot = (e, t, r, n) => {
  for (const i of r || Object.keys(e)) {
    const s = k(e, i);
    if (s) {
      const { _f: o, ...a } = s;
      if (o) {
        if (o.refs && o.refs[0] && t(o.refs[0], i) && !n)
          return !0;
        if (o.ref && t(o.ref, o.name) && !n)
          return !0;
        if (Ot(a, t))
          break;
      } else if (te(a) && Ot(a, t))
        break;
    }
  }
};
function bn(e, t, r) {
  const n = k(e, r);
  if (n || lr(r))
    return {
      error: n,
      name: r
    };
  const i = r.split(".");
  for (; i.length; ) {
    const s = i.join("."), o = k(t, s), a = k(e, s);
    if (o && !Array.isArray(o) && r !== s)
      return { name: r };
    if (a && a.type)
      return {
        name: s,
        error: a
      };
    if (a && a.root && a.root.type)
      return {
        name: `${s}.root`,
        error: a.root
      };
    i.pop();
  }
  return {
    name: r
  };
}
var oa = (e, t, r, n) => {
  r(e);
  const { name: i, ...s } = e;
  return fe(s) || Object.keys(s).length >= Object.keys(t).length || Object.keys(s).find((o) => t[o] === (!n || Oe.all));
}, aa = (e, t, r) => !e || !t || e === t || Nt(e).some((n) => n && (r ? n === t : n.startsWith(t) || t.startsWith(n))), la = (e, t, r, n, i) => i.isOnAll ? !1 : !r && i.isOnTouch ? !(t || e) : (r ? n.isOnBlur : i.isOnBlur) ? !e : (r ? n.isOnChange : i.isOnChange) ? e : !0, ca = (e, t) => !Mr(k(e, t)).length && re(e, t), ua = (e, t, r) => {
  const n = Nt(k(e, r));
  return z(n, "root", t[r]), z(e, r, n), e;
}, Zt = (e) => Ae(e);
function yn(e, t, r = "validate") {
  if (Zt(e) || Array.isArray(e) && e.every(Zt) || pe(e) && !e)
    return {
      type: r,
      message: Zt(e) ? e : "",
      ref: t
    };
}
var st = (e) => te(e) && !rr(e) ? e : {
  value: e,
  message: ""
}, wn = async (e, t, r, n, i, s) => {
  const { ref: o, refs: a, required: l, maxLength: u, minLength: c, min: f, max: p, pattern: m, validate: C, name: b, valueAsNumber: y, mount: _ } = e._f, w = k(r, b);
  if (!_ || t.has(b))
    return {};
  const M = a ? a[0] : o, S = (D) => {
    i && M.reportValidity && (M.setCustomValidity(pe(D) ? "" : D || ""), M.reportValidity());
  }, L = {}, V = Ir(o), O = Tt(o), $ = V || O, j = (y || jr(o)) && ee(o.value) && ee(w) || er(o) && o.value === "" || w === "" || Array.isArray(w) && !w.length, H = li.bind(null, b, n, L), R = (D, I, W, J = Me.maxLength, Z = Me.minLength) => {
    const Q = D ? I : W;
    L[b] = {
      type: D ? J : Z,
      message: Q,
      ref: o,
      ...H(D ? J : Z, Q)
    };
  };
  if (s ? !Array.isArray(w) || !w.length : l && (!$ && (j || ae(w)) || pe(w) && !w || O && !di(a).isValid || V && !pi(a).isValid)) {
    const { value: D, message: I } = Zt(l) ? { value: !!l, message: l } : st(l);
    if (D && (L[b] = {
      type: Me.required,
      message: I,
      ref: M,
      ...H(Me.required, I)
    }, !n))
      return S(I), L;
  }
  if (!j && (!ae(f) || !ae(p))) {
    let D, I;
    const W = st(p), J = st(f);
    if (!ae(w) && !isNaN(w)) {
      const Z = o.valueAsNumber || w && +w;
      ae(W.value) || (D = Z > W.value), ae(J.value) || (I = Z < J.value);
    } else {
      const Z = o.valueAsDate || new Date(w), Q = (Te) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + Te), Ee = o.type == "time", ue = o.type == "week";
      Ae(W.value) && w && (D = Ee ? Q(w) > Q(W.value) : ue ? w > W.value : Z > new Date(W.value)), Ae(J.value) && w && (I = Ee ? Q(w) < Q(J.value) : ue ? w < J.value : Z < new Date(J.value));
    }
    if ((D || I) && (R(!!D, W.message, J.message, Me.max, Me.min), !n))
      return S(L[b].message), L;
  }
  if ((u || c) && !j && (Ae(w) || s && Array.isArray(w))) {
    const D = st(u), I = st(c), W = !ae(D.value) && w.length > +D.value, J = !ae(I.value) && w.length < +I.value;
    if ((W || J) && (R(W, D.message, I.message), !n))
      return S(L[b].message), L;
  }
  if (m && !j && Ae(w)) {
    const { value: D, message: I } = st(m);
    if (rr(D) && !w.match(D) && (L[b] = {
      type: Me.pattern,
      message: I,
      ref: o,
      ...H(Me.pattern, I)
    }, !n))
      return S(I), L;
  }
  if (C) {
    if (ke(C)) {
      const D = await C(w, r), I = yn(D, M);
      if (I && (L[b] = {
        ...I,
        ...H(Me.validate, I.message)
      }, !n))
        return S(I.message), L;
    } else if (te(C)) {
      let D = {};
      for (const I in C) {
        if (!fe(D) && !n)
          break;
        const W = yn(await C[I](w, r), M, I);
        W && (D = {
          ...W,
          ...H(I, W.message)
        }, S(W.message), n && (L[b] = D));
      }
      if (!fe(D) && (L[b] = {
        ref: M,
        ...D
      }, !n))
        return L;
    }
  }
  return S(!0), L;
};
const fa = {
  mode: Oe.onSubmit,
  reValidateMode: Oe.onChange,
  shouldFocusError: !0
};
function da(e = {}) {
  let t = {
    ...fa,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isReady: !1,
    isLoading: ke(t.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: t.errors || {},
    disabled: t.disabled || !1
  }, n = {}, i = te(t.defaultValues) || te(t.values) ? ie(t.defaultValues || t.values) || {} : {}, s = t.shouldUnregister ? {} : ie(i), o = {
    action: !1,
    mount: !1,
    watch: !1
  }, a = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, l, u = 0;
  const c = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...c
  };
  const p = {
    array: un(),
    state: un()
  }, m = t.criteriaMode === Oe.all, C = (d) => (v) => {
    clearTimeout(u), u = setTimeout(d, v);
  }, b = async (d) => {
    if (!t.disabled && (c.isValid || f.isValid || d)) {
      const v = t.resolver ? fe((await O()).errors) : await j(n, !0);
      v !== r.isValid && p.state.next({
        isValid: v
      });
    }
  }, y = (d, v) => {
    !t.disabled && (c.isValidating || c.validatingFields || f.isValidating || f.validatingFields) && ((d || Array.from(a.mount)).forEach((g) => {
      g && (v ? z(r.validatingFields, g, v) : re(r.validatingFields, g));
    }), p.state.next({
      validatingFields: r.validatingFields,
      isValidating: !fe(r.validatingFields)
    }));
  }, _ = (d, v = [], g, A, N = !0, x = !0) => {
    if (A && g && !t.disabled) {
      if (o.action = !0, x && Array.isArray(k(n, d))) {
        const P = g(k(n, d), A.argA, A.argB);
        N && z(n, d, P);
      }
      if (x && Array.isArray(k(r.errors, d))) {
        const P = g(k(r.errors, d), A.argA, A.argB);
        N && z(r.errors, d, P), ca(r.errors, d);
      }
      if ((c.touchedFields || f.touchedFields) && x && Array.isArray(k(r.touchedFields, d))) {
        const P = g(k(r.touchedFields, d), A.argA, A.argB);
        N && z(r.touchedFields, d, P);
      }
      (c.dirtyFields || f.dirtyFields) && (r.dirtyFields = yt(i, s)), p.state.next({
        name: d,
        isDirty: R(d, v),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      z(s, d, v);
  }, w = (d, v) => {
    z(r.errors, d, v), p.state.next({
      errors: r.errors
    });
  }, M = (d) => {
    r.errors = d, p.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, S = (d, v, g, A) => {
    const N = k(n, d);
    if (N) {
      const x = k(s, d, ee(g) ? k(i, d) : g);
      ee(x) || A && A.defaultChecked || v ? z(s, d, v ? x : pn(N._f)) : W(d, x), o.mount && b();
    }
  }, L = (d, v, g, A, N) => {
    let x = !1, P = !1;
    const U = {
      name: d
    };
    if (!t.disabled) {
      if (!g || A) {
        (c.isDirty || f.isDirty) && (P = r.isDirty, r.isDirty = U.isDirty = R(), x = P !== U.isDirty);
        const q = Ue(k(i, d), v);
        P = !!k(r.dirtyFields, d), q ? re(r.dirtyFields, d) : z(r.dirtyFields, d, !0), U.dirtyFields = r.dirtyFields, x = x || (c.dirtyFields || f.dirtyFields) && P !== !q;
      }
      if (g) {
        const q = k(r.touchedFields, d);
        q || (z(r.touchedFields, d, g), U.touchedFields = r.touchedFields, x = x || (c.touchedFields || f.touchedFields) && q !== g);
      }
      x && N && p.state.next(U);
    }
    return x ? U : {};
  }, V = (d, v, g, A) => {
    const N = k(r.errors, d), x = (c.isValid || f.isValid) && pe(v) && r.isValid !== v;
    if (t.delayError && g ? (l = C(() => w(d, g)), l(t.delayError)) : (clearTimeout(u), l = null, g ? z(r.errors, d, g) : re(r.errors, d)), (g ? !Ue(N, g) : N) || !fe(A) || x) {
      const P = {
        ...A,
        ...x && pe(v) ? { isValid: v } : {},
        errors: r.errors,
        name: d
      };
      r = {
        ...r,
        ...P
      }, p.state.next(P);
    }
  }, O = async (d) => {
    y(d, !0);
    const v = await t.resolver(s, t.context, na(d || a.mount, n, t.criteriaMode, t.shouldUseNativeValidation));
    return y(d), v;
  }, $ = async (d) => {
    const { errors: v } = await O(d);
    if (d)
      for (const g of d) {
        const A = k(v, g);
        A ? z(r.errors, g, A) : re(r.errors, g);
      }
    else
      r.errors = v;
    return v;
  }, j = async (d, v, g = {
    valid: !0
  }) => {
    for (const A in d) {
      const N = d[A];
      if (N) {
        const { _f: x, ...P } = N;
        if (x) {
          const U = a.array.has(x.name), q = N._f && ia(N._f);
          q && c.validatingFields && y([A], !0);
          const ge = await wn(N, a.disabled, s, m, t.shouldUseNativeValidation && !v, U);
          if (q && c.validatingFields && y([A]), ge[x.name] && (g.valid = !1, v))
            break;
          !v && (k(ge, x.name) ? U ? ua(r.errors, ge, x.name) : z(r.errors, x.name, ge[x.name]) : re(r.errors, x.name));
        }
        !fe(P) && await j(P, v, g);
      }
    }
    return g.valid;
  }, H = () => {
    for (const d of a.unMount) {
      const v = k(n, d);
      v && (v._f.refs ? v._f.refs.every((g) => !dr(g)) : !dr(v._f.ref)) && Ie(d);
    }
    a.unMount = /* @__PURE__ */ new Set();
  }, R = (d, v) => !t.disabled && (d && v && z(s, d, v), !Ue(Te(), i)), D = (d, v, g) => oi(d, a, {
    ...o.mount ? s : ee(v) ? i : Ae(d) ? { [d]: v } : v
  }, g, v), I = (d) => Mr(k(o.mount ? s : i, d, t.shouldUnregister ? k(i, d, []) : [])), W = (d, v, g = {}) => {
    const A = k(n, d);
    let N = v;
    if (A) {
      const x = A._f;
      x && (!x.disabled && z(s, d, hi(v, x)), N = er(x.ref) && ae(v) ? "" : v, ci(x.ref) ? [...x.ref.options].forEach((P) => P.selected = N.includes(P.value)) : x.refs ? Tt(x.ref) ? x.refs.forEach((P) => {
        (!P.defaultChecked || !P.disabled) && (Array.isArray(N) ? P.checked = !!N.find((U) => U === P.value) : P.checked = N === P.value || !!N);
      }) : x.refs.forEach((P) => P.checked = P.value === N) : jr(x.ref) ? x.ref.value = "" : (x.ref.value = N, x.ref.type || p.state.next({
        name: d,
        values: ie(s)
      })));
    }
    (g.shouldDirty || g.shouldTouch) && L(d, N, g.shouldTouch, g.shouldDirty, !0), g.shouldValidate && ue(d);
  }, J = (d, v, g) => {
    for (const A in v) {
      if (!v.hasOwnProperty(A))
        return;
      const N = v[A], x = d + "." + A, P = k(n, x);
      (a.array.has(d) || te(N) || P && !P._f) && !Ke(N) ? J(x, N, g) : W(x, N, g);
    }
  }, Z = (d, v, g = {}) => {
    const A = k(n, d), N = a.array.has(d), x = ie(v);
    z(s, d, x), N ? (p.array.next({
      name: d,
      values: ie(s)
    }), (c.isDirty || c.dirtyFields || f.isDirty || f.dirtyFields) && g.shouldDirty && p.state.next({
      name: d,
      dirtyFields: yt(i, s),
      isDirty: R(d, x)
    })) : A && !A._f && !ae(x) ? J(d, x, g) : W(d, x, g), gn(d, a) && p.state.next({ ...r }), p.state.next({
      name: o.mount ? d : void 0,
      values: ie(s)
    });
  }, Q = async (d) => {
    o.mount = !0;
    const v = d.target;
    let g = v.name, A = !0;
    const N = k(n, g), x = (q) => {
      A = Number.isNaN(q) || Ke(q) && isNaN(q.getTime()) || Ue(q, k(s, g, q));
    }, P = vn(t.mode), U = vn(t.reValidateMode);
    if (N) {
      let q, ge;
      const Ht = v.type ? pn(N._f) : ri(d), $e = d.type === Qt.BLUR || d.type === Qt.FOCUS_OUT, Oi = !sa(N._f) && !t.resolver && !k(r.errors, g) && !N._f.deps || la($e, k(r.touchedFields, g), r.isSubmitted, U, P), cr = gn(g, a, $e);
      z(s, g, Ht), $e ? (N._f.onBlur && N._f.onBlur(d), l && l(0)) : N._f.onChange && N._f.onChange(d);
      const ur = L(g, Ht, $e), ki = !fe(ur) || cr;
      if (!$e && p.state.next({
        name: g,
        type: d.type,
        values: ie(s)
      }), Oi)
        return (c.isValid || f.isValid) && (t.mode === "onBlur" ? $e && b() : $e || b()), ki && p.state.next({ name: g, ...cr ? {} : ur });
      if (!$e && cr && p.state.next({ ...r }), t.resolver) {
        const { errors: zr } = await O([g]);
        if (x(Ht), A) {
          const Ei = bn(r.errors, n, g), Zr = bn(zr, n, Ei.name || g);
          q = Zr.error, g = Zr.name, ge = fe(zr);
        }
      } else
        y([g], !0), q = (await wn(N, a.disabled, s, m, t.shouldUseNativeValidation))[g], y([g]), x(Ht), A && (q ? ge = !1 : (c.isValid || f.isValid) && (ge = await j(n, !0)));
      A && (N._f.deps && ue(N._f.deps), V(g, ge, q, ur));
    }
  }, Ee = (d, v) => {
    if (k(r.errors, v) && d.focus)
      return d.focus(), 1;
  }, ue = async (d, v = {}) => {
    let g, A;
    const N = Nt(d);
    if (t.resolver) {
      const x = await $(ee(d) ? d : N);
      g = fe(x), A = d ? !N.some((P) => k(x, P)) : g;
    } else d ? (A = (await Promise.all(N.map(async (x) => {
      const P = k(n, x);
      return await j(P && P._f ? { [x]: P } : P);
    }))).every(Boolean), !(!A && !r.isValid) && b()) : A = g = await j(n);
    return p.state.next({
      ...!Ae(d) || (c.isValid || f.isValid) && g !== r.isValid ? {} : { name: d },
      ...t.resolver || !d ? { isValid: g } : {},
      errors: r.errors
    }), v.shouldFocus && !A && Ot(n, Ee, d ? N : a.mount), A;
  }, Te = (d) => {
    const v = {
      ...o.mount ? s : i
    };
    return ee(d) ? v : Ae(d) ? k(v, d) : d.map((g) => k(v, g));
  }, it = (d, v) => ({
    invalid: !!k((v || r).errors, d),
    isDirty: !!k((v || r).dirtyFields, d),
    error: k((v || r).errors, d),
    isValidating: !!k(r.validatingFields, d),
    isTouched: !!k((v || r).touchedFields, d)
  }), ze = (d) => {
    d && Nt(d).forEach((v) => re(r.errors, v)), p.state.next({
      errors: d ? r.errors : {}
    });
  }, Ze = (d, v, g) => {
    const A = (k(n, d, { _f: {} })._f || {}).ref, N = k(r.errors, d) || {}, { ref: x, message: P, type: U, ...q } = N;
    z(r.errors, d, {
      ...q,
      ...v,
      ref: A
    }), p.state.next({
      name: d,
      errors: r.errors,
      isValid: !1
    }), g && g.shouldFocus && A && A.focus && A.focus();
  }, je = (d, v) => ke(d) ? p.state.subscribe({
    next: (g) => d(D(void 0, v), g)
  }) : D(d, v, !0), Ne = (d) => p.state.subscribe({
    next: (v) => {
      aa(d.name, v.name, d.exact) && oa(v, d.formState || c, It, d.reRenderRoot) && d.callback({
        values: { ...s },
        ...r,
        ...v
      });
    }
  }).unsubscribe, Xe = (d) => (o.mount = !0, f = {
    ...f,
    ...d.formState
  }, Ne({
    ...d,
    formState: f
  })), Ie = (d, v = {}) => {
    for (const g of d ? Nt(d) : a.mount)
      a.mount.delete(g), a.array.delete(g), v.keepValue || (re(n, g), re(s, g)), !v.keepError && re(r.errors, g), !v.keepDirty && re(r.dirtyFields, g), !v.keepTouched && re(r.touchedFields, g), !v.keepIsValidating && re(r.validatingFields, g), !t.shouldUnregister && !v.keepDefaultValue && re(i, g);
    p.state.next({
      values: ie(s)
    }), p.state.next({
      ...r,
      ...v.keepDirty ? { isDirty: R() } : {}
    }), !v.keepIsValid && b();
  }, Se = ({ disabled: d, name: v }) => {
    (pe(d) && o.mount || d || a.disabled.has(v)) && (d ? a.disabled.add(v) : a.disabled.delete(v));
  }, Ye = (d, v = {}) => {
    let g = k(n, d);
    const A = pe(v.disabled) || pe(t.disabled);
    return z(n, d, {
      ...g || {},
      _f: {
        ...g && g._f ? g._f : { ref: { name: d } },
        name: d,
        mount: !0,
        ...v
      }
    }), a.mount.add(d), g ? Se({
      disabled: pe(v.disabled) ? v.disabled : t.disabled,
      name: d
    }) : S(d, !0, v.value), {
      ...A ? { disabled: v.disabled || t.disabled } : {},
      ...t.progressive ? {
        required: !!v.required,
        min: wt(v.min),
        max: wt(v.max),
        minLength: wt(v.minLength),
        maxLength: wt(v.maxLength),
        pattern: wt(v.pattern)
      } : {},
      name: d,
      onChange: Q,
      onBlur: Q,
      ref: (N) => {
        if (N) {
          Ye(d, v), g = k(n, d);
          const x = ee(N.value) && N.querySelectorAll && N.querySelectorAll("input,select,textarea")[0] || N, P = ea(x), U = g._f.refs || [];
          if (P ? U.find((q) => q === x) : x === g._f.ref)
            return;
          z(n, d, {
            _f: {
              ...g._f,
              ...P ? {
                refs: [
                  ...U.filter(dr),
                  x,
                  ...Array.isArray(k(i, d)) ? [{}] : []
                ],
                ref: { type: x.type, name: d }
              } : { ref: x }
            }
          }), S(d, !1, void 0, x);
        } else
          g = k(n, d, {}), g._f && (g._f.mount = !1), (t.shouldUnregister || v.shouldUnregister) && !(ni(a.array, d) && o.action) && a.unMount.add(d);
      }
    };
  }, mt = () => t.shouldFocusError && Ot(n, Ee, a.mount), gt = (d) => {
    pe(d) && (p.state.next({ disabled: d }), Ot(n, (v, g) => {
      const A = k(n, g);
      A && (v.disabled = A._f.disabled || d, Array.isArray(A._f.refs) && A._f.refs.forEach((N) => {
        N.disabled = A._f.disabled || d;
      }));
    }, 0, !1));
  }, Mt = (d, v) => async (g) => {
    let A;
    g && (g.preventDefault && g.preventDefault(), g.persist && g.persist());
    let N = ie(s);
    if (p.state.next({
      isSubmitting: !0
    }), t.resolver) {
      const { errors: x, values: P } = await O();
      r.errors = x, N = ie(P);
    } else
      await j(n);
    if (a.disabled.size)
      for (const x of a.disabled)
        re(N, x);
    if (re(r.errors, "root"), fe(r.errors)) {
      p.state.next({
        errors: {}
      });
      try {
        await d(N, g);
      } catch (x) {
        A = x;
      }
    } else
      v && await v({ ...r.errors }, g), mt(), setTimeout(mt);
    if (p.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: fe(r.errors) && !A,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), A)
      throw A;
  }, Pt = (d, v = {}) => {
    k(n, d) && (ee(v.defaultValue) ? Z(d, ie(k(i, d))) : (Z(d, v.defaultValue), z(i, d, ie(v.defaultValue))), v.keepTouched || re(r.touchedFields, d), v.keepDirty || (re(r.dirtyFields, d), r.isDirty = v.defaultValue ? R(d, ie(k(i, d))) : R()), v.keepError || (re(r.errors, d), c.isValid && b()), p.state.next({ ...r }));
  }, Rt = (d, v = {}) => {
    const g = d ? ie(d) : i, A = ie(g), N = fe(d), x = N ? i : A;
    if (v.keepDefaultValues || (i = g), !v.keepValues) {
      if (v.keepDirtyValues) {
        const P = /* @__PURE__ */ new Set([
          ...a.mount,
          ...Object.keys(yt(i, s))
        ]);
        for (const U of Array.from(P))
          k(r.dirtyFields, U) ? z(x, U, k(s, U)) : Z(U, k(x, U));
      } else {
        if (Tr && ee(d))
          for (const P of a.mount) {
            const U = k(n, P);
            if (U && U._f) {
              const q = Array.isArray(U._f.refs) ? U._f.refs[0] : U._f.ref;
              if (er(q)) {
                const ge = q.closest("form");
                if (ge) {
                  ge.reset();
                  break;
                }
              }
            }
          }
        if (v.keepFieldsRef)
          for (const P of a.mount)
            Z(P, k(x, P));
        else
          n = {};
      }
      s = t.shouldUnregister ? v.keepDefaultValues ? ie(i) : {} : ie(x), p.array.next({
        values: { ...x }
      }), p.state.next({
        values: { ...x }
      });
    }
    a = {
      mount: v.keepDirtyValues ? a.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, o.mount = !c.isValid || !!v.keepIsValid || !!v.keepDirtyValues, o.watch = !!t.shouldUnregister, p.state.next({
      submitCount: v.keepSubmitCount ? r.submitCount : 0,
      isDirty: N ? !1 : v.keepDirty ? r.isDirty : !!(v.keepDefaultValues && !Ue(d, i)),
      isSubmitted: v.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: N ? {} : v.keepDirtyValues ? v.keepDefaultValues && s ? yt(i, s) : r.dirtyFields : v.keepDefaultValues && d ? yt(i, d) : v.keepDirty ? r.dirtyFields : {},
      touchedFields: v.keepTouched ? r.touchedFields : {},
      errors: v.keepErrors ? r.errors : {},
      isSubmitSuccessful: v.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Bt = (d, v) => Rt(ke(d) ? d(s) : d, v), jt = (d, v = {}) => {
    const g = k(n, d), A = g && g._f;
    if (A) {
      const N = A.refs ? A.refs[0] : A.ref;
      N.focus && (N.focus(), v.shouldSelect && ke(N.select) && N.select());
    }
  }, It = (d) => {
    r = {
      ...r,
      ...d
    };
  }, $t = {
    control: {
      register: Ye,
      unregister: Ie,
      getFieldState: it,
      handleSubmit: Mt,
      setError: Ze,
      _subscribe: Ne,
      _runSchema: O,
      _focusError: mt,
      _getWatch: D,
      _getDirty: R,
      _setValid: b,
      _setFieldArray: _,
      _setDisabledField: Se,
      _setErrors: M,
      _getFieldArray: I,
      _reset: Rt,
      _resetDefaultValues: () => ke(t.defaultValues) && t.defaultValues().then((d) => {
        Bt(d, t.resetOptions), p.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: H,
      _disableForm: gt,
      _subjects: p,
      _proxyFormState: c,
      get _fields() {
        return n;
      },
      get _formValues() {
        return s;
      },
      get _state() {
        return o;
      },
      set _state(d) {
        o = d;
      },
      get _defaultValues() {
        return i;
      },
      get _names() {
        return a;
      },
      set _names(d) {
        a = d;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return t;
      },
      set _options(d) {
        t = {
          ...t,
          ...d
        };
      }
    },
    subscribe: Xe,
    trigger: ue,
    register: Ye,
    handleSubmit: Mt,
    watch: je,
    setValue: Z,
    getValues: Te,
    reset: Bt,
    resetField: Pt,
    clearErrors: ze,
    unregister: Ie,
    setError: Ze,
    setFocus: jt,
    getFieldState: it
  };
  return {
    ...$t,
    formControl: $t
  };
}
function ha(e = {}) {
  const t = B.useRef(void 0), r = B.useRef(void 0), [n, i] = B.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: ke(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    isReady: !1,
    defaultValues: ke(e.defaultValues) ? void 0 : e.defaultValues
  });
  if (!t.current)
    if (e.formControl)
      t.current = {
        ...e.formControl,
        formState: n
      }, e.defaultValues && !ke(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions);
    else {
      const { formControl: o, ...a } = da(e);
      t.current = {
        ...a,
        formState: n
      };
    }
  const s = t.current.control;
  return s._options = e, Br(() => {
    const o = s._subscribe({
      formState: s._proxyFormState,
      callback: () => i({ ...s._formState }),
      reRenderRoot: !0
    });
    return i((a) => ({
      ...a,
      isReady: !0
    })), s._formState.isReady = !0, o;
  }, [s]), B.useEffect(() => s._disableForm(e.disabled), [s, e.disabled]), B.useEffect(() => {
    e.mode && (s._options.mode = e.mode), e.reValidateMode && (s._options.reValidateMode = e.reValidateMode);
  }, [s, e.mode, e.reValidateMode]), B.useEffect(() => {
    e.errors && (s._setErrors(e.errors), s._focusError());
  }, [s, e.errors]), B.useEffect(() => {
    e.shouldUnregister && s._subjects.state.next({
      values: s._getWatch()
    });
  }, [s, e.shouldUnregister]), B.useEffect(() => {
    if (s._proxyFormState.isDirty) {
      const o = s._getDirty();
      o !== n.isDirty && s._subjects.state.next({
        isDirty: o
      });
    }
  }, [s, n.isDirty]), B.useEffect(() => {
    e.values && !Ue(e.values, r.current) ? (s._reset(e.values, {
      keepFieldsRef: !0,
      ...s._options.resetOptions
    }), r.current = e.values, i((o) => ({ ...o }))) : s._resetDefaultValues();
  }, [s, e.values]), B.useEffect(() => {
    s._state.mount || (s._setValid(), s._state.mount = !0), s._state.watch && (s._state.watch = !1, s._subjects.state.next({ ...s._formState })), s._removeUnmounted();
  }), t.current.formState = ii(n, s), t.current;
}
const xn = (e, t, r) => {
  if (e && "reportValidity" in e) {
    const n = k(r, t);
    e.setCustomValidity(n && n.message || ""), e.reportValidity();
  }
}, vi = (e, t) => {
  for (const r in t.fields) {
    const n = t.fields[r];
    n && n.ref && "reportValidity" in n.ref ? xn(n.ref, r, e) : n.refs && n.refs.forEach((i) => xn(i, r, e));
  }
}, pa = (e, t) => {
  t.shouldUseNativeValidation && vi(e, t);
  const r = {};
  for (const n in e) {
    const i = k(t.fields, n), s = Object.assign(e[n] || {}, { ref: i && i.ref });
    if (va(t.names || Object.keys(e), n)) {
      const o = Object.assign({}, k(r, n));
      z(o, "root", s), z(r, n, o);
    } else z(r, n, s);
  }
  return r;
}, va = (e, t) => e.some((r) => r.startsWith(t + "."));
function ma(e, t, r) {
  return t === void 0 && (t = {}), r === void 0 && (r = {}), function(n, i, s) {
    try {
      return Promise.resolve(function(o, a) {
        try {
          var l = (t.context && process.env.NODE_ENV === "development" && console.warn("You should not used the yup options context. Please, use the 'useForm' context object instead"), Promise.resolve(e[r.mode === "sync" ? "validateSync" : "validate"](n, Object.assign({ abortEarly: !1 }, t, { context: i }))).then(function(u) {
            return s.shouldUseNativeValidation && vi({}, s), { values: r.raw ? n : u, errors: {} };
          }));
        } catch (u) {
          return a(u);
        }
        return l && l.then ? l.then(void 0, a) : l;
      }(0, function(o) {
        if (!o.inner) throw o;
        return { values: {}, errors: pa((a = o, l = !s.shouldUseNativeValidation && s.criteriaMode === "all", (a.inner || []).reduce(function(u, c) {
          if (u[c.path] || (u[c.path] = { message: c.message, type: c.type }), l) {
            var f = u[c.path].types, p = f && f[c.type];
            u[c.path] = li(c.path, l, u, c.type, p ? [].concat(p, c.message) : c.message);
          }
          return u;
        }, {})), s) };
        var a, l;
      }));
    } catch (o) {
      return Promise.reject(o);
    }
  };
}
function pl({
  className: e,
  name: t,
  children: r,
  mode: n = "onBlur",
  reValidateMode: i = "onBlur",
  defaultValues: s,
  schema: o,
  formProps: a,
  onSubmit: l = () => null,
  onChange: u
}) {
  const c = ha({
    mode: n,
    reValidateMode: i,
    defaultValues: s,
    resolver: o ? ma(o) : void 0
  });
  return ce(() => {
    if (!u) return;
    const { unsubscribe: f } = c.watch(u);
    return f;
  }, [u, c.watch]), /* @__PURE__ */ h(Jo, { ...c, children: /* @__PURE__ */ h(
    "form",
    {
      className: F("bbn-form", e),
      name: t,
      onSubmit: c.handleSubmit(l),
      ...a,
      children: r
    }
  ) });
}
function ht({
  name: e,
  defaultValue: t,
  disabled: r = !1,
  autoFocus: n = !1,
  shouldUnregister: i = !1,
  validateOnMount: s = !0
}) {
  const { setFocus: o, trigger: a } = dt(), { field: l, fieldState: u } = Qo({ name: e, defaultValue: t, disabled: r, shouldUnregister: i }), { invalid: c, isTouched: f, error: p } = u;
  return ce(() => {
    s ? a(e, { shouldFocus: n }) : n && o(e);
  }, [e, s]), {
    ...l,
    value: l.value,
    invalid: c && f,
    error: (p == null ? void 0 : p.message) ?? ""
  };
}
function vl(e) {
  const { getFieldState: t } = dt(), r = si({ name: e });
  return Array.isArray(e) ? e.map((i) => t(i, r)) : t(e, r);
}
const ga = /^-?\d*\.?\d*$/;
function ml({
  name: e,
  id: t = e,
  label: r,
  hint: n,
  className: i,
  controlClassName: s,
  disabled: o,
  autoFocus: a,
  defaultValue: l,
  placeholder: u,
  type: c,
  suffix: f,
  prefix: p,
  shouldUnregister: m,
  state: C,
  validateOnMount: b
}) {
  const {
    ref: y,
    value: _ = "",
    error: w,
    invalid: M,
    onChange: S,
    onBlur: L
  } = ht({ name: e, defaultValue: l, autoFocus: a, shouldUnregister: m, validateOnMount: b }), V = M ? "error" : C;
  return /* @__PURE__ */ h(ar, { label: r, className: s, state: V, hint: M ? w : n, children: /* @__PURE__ */ h(
    Vr,
    {
      inputMode: "decimal",
      pattern: "^-?\\d*\\.?\\d*$",
      ref: y,
      value: _,
      id: t,
      name: e,
      type: c,
      className: i,
      disabled: o,
      autoFocus: a,
      placeholder: u,
      suffix: f,
      prefix: p,
      state: V,
      onChange: (j) => {
        ga.test(j.target.value) && S(j.target.value);
      },
      onBlur: L
    }
  ) });
}
function gl({
  name: e,
  id: t = e,
  label: r,
  hint: n,
  className: i,
  controlClassName: s,
  disabled: o,
  autoFocus: a,
  defaultValue: l,
  placeholder: u,
  type: c,
  suffix: f,
  prefix: p,
  shouldUnregister: m,
  state: C,
  validateOnMount: b
}) {
  const {
    ref: y,
    value: _ = "",
    error: w,
    invalid: M,
    onChange: S,
    onBlur: L
  } = ht({ name: e, defaultValue: l, autoFocus: a, shouldUnregister: m, validateOnMount: b }), V = M ? "error" : C;
  return /* @__PURE__ */ h(ar, { label: r, className: s, state: V, hint: M ? w : n, children: /* @__PURE__ */ h(
    Vr,
    {
      ref: y,
      value: _,
      id: t,
      name: e,
      type: c,
      className: i,
      disabled: o,
      autoFocus: a,
      placeholder: u,
      suffix: f,
      prefix: p,
      state: V,
      onChange: S,
      onBlur: L
    }
  ) });
}
function bl({
  name: e,
  id: t = e,
  label: r,
  className: n,
  disabled: i,
  value: s,
  defaultChecked: o,
  labelClassName: a,
  orientation: l
}) {
  const { ref: u, value: c = !1, onChange: f, onBlur: p } = ht({ name: e });
  return /* @__PURE__ */ h(
    _i,
    {
      ref: u,
      name: e,
      checked: c,
      id: t,
      label: r,
      className: n,
      disabled: i,
      value: s,
      defaultChecked: o,
      labelClassName: a,
      orientation: l,
      inputProps: { onChange: f, onBlur: p }
    }
  );
}
function yl({
  name: e,
  id: t = e,
  label: r,
  className: n,
  disabled: i,
  value: s,
  defaultChecked: o,
  labelClassName: a,
  orientation: l
}) {
  const {
    ref: u,
    value: c,
    onChange: f,
    onBlur: p
  } = ht({ name: e, disabled: i, defaultValue: o ? s : void 0 });
  return /* @__PURE__ */ h(
    Ti,
    {
      ref: u,
      name: e,
      id: t,
      label: r,
      className: n,
      disabled: i,
      checked: c === s,
      value: s,
      labelClassName: a,
      orientation: l,
      inputProps: { onChange: f, onBlur: p }
    }
  );
}
function wl({
  open: e,
  defaultOpen: t,
  options: r,
  optionClassName: n,
  popoverClassName: i,
  name: s,
  id: o = s,
  label: a,
  hint: l,
  className: u,
  controlClassName: c,
  disabled: f,
  autoFocus: p,
  defaultValue: m,
  placeholder: C,
  shouldUnregister: b,
  state: y,
  validateOnMount: _,
  onOpen: w,
  onClose: M,
  renderSelectedOption: S
}) {
  const {
    ref: L,
    value: V = "",
    error: O,
    invalid: $,
    onChange: j,
    onBlur: H
  } = ht({ name: s, defaultValue: m, autoFocus: p, shouldUnregister: b, validateOnMount: _ }), R = $ ? "error" : y;
  return /* @__PURE__ */ h(ar, { label: a, className: c, state: R, hint: $ ? O : l, children: /* @__PURE__ */ h(
    Hn,
    {
      open: e,
      defaultOpen: t,
      options: r,
      ref: L,
      value: V,
      id: o,
      name: s,
      className: u,
      disabled: f,
      placeholder: C,
      state: R,
      optionClassName: n,
      popoverClassName: i,
      onSelect: j,
      onBlur: H,
      onOpen: w,
      onClose: () => {
        H == null || H(), M == null || M();
      },
      renderSelectedOption: S
    }
  ) });
}
function ba({ displayError: e = !1, ...t }) {
  const { error: r, value: n, onChange: i, onBlur: s, disabled: o, name: a, ref: l } = ht(t), u = /* @__PURE__ */ h("input", { ref: l, type: "hidden", name: a, disabled: o, value: n, onChange: i, onBlur: s });
  return e ? /* @__PURE__ */ h(ar, { hint: e ? r : "", state: e ? "error" : "default", children: u }) : u;
}
const ya = {
  lg: {
    logo: "size-10",
    subLogo: "text-[0.8rem]"
  },
  md: {
    logo: "size-6",
    subLogo: "text-[0.5rem]"
  },
  sm: {
    logo: "size-5",
    subLogo: "text-[0.4rem]"
  }
}, wa = ({ logoUrl: e, rank: t, moniker: r, size: n = "md", className: i }) => {
  const [s, o] = oe(!1), a = ya[n], l = (r == null ? void 0 : r.charAt(0).toUpperCase()) ?? String(t);
  return /* @__PURE__ */ h("span", { className: be("relative inline-block", a.logo, i), children: e && !s ? /* @__PURE__ */ h(
    "img",
    {
      src: e,
      alt: r || `Finality Provider ${t}`,
      className: "h-full w-full rounded-full object-cover",
      onError: () => o(!0)
    }
  ) : /* @__PURE__ */ h(
    X,
    {
      as: "span",
      className: "inline-flex h-full w-full items-center justify-center rounded-full bg-secondary-main text-[1rem] text-accent-contrast",
      children: l
    }
  ) });
};
function mi({ bsnId: e, bsnName: t, bsnLogoUrl: r, address: n, provider: i, onRemove: s }) {
  var u, c;
  if (!i) return null;
  const o = () => {
    if (r)
      return /* @__PURE__ */ h(pr, { url: r, alt: t, variant: "rounded", size: "tiny", className: "mr-1" });
    const f = (t == null ? void 0 : t.charAt(0).toUpperCase()) || "?";
    return /* @__PURE__ */ h(pr, { variant: "rounded", size: "tiny", className: "mr-1", children: /* @__PURE__ */ h(
      X,
      {
        as: "span",
        className: "inline-flex h-full w-full items-center justify-center bg-secondary-main text-xs text-accent-contrast",
        children: f
      }
    ) });
  }, a = (f) => !f || f.length <= 6 * 2 ? f : `${f.slice(0, 6)}...${f.slice(-6)}`, l = () => n ? /* @__PURE__ */ h("div", { className: "text-xs text-accent-secondary", children: a(n) }) : /* @__PURE__ */ E("div", { className: "flex items-center text-xs text-accent-secondary", children: [
    o(),
    t
  ] });
  return /* @__PURE__ */ E("div", { className: "flex flex-row items-center justify-between", children: [
    /* @__PURE__ */ E("div", { className: "flex h-10 flex-row gap-2", children: [
      /* @__PURE__ */ h("div", { className: "shrink-0", children: /* @__PURE__ */ h(
        wa,
        {
          logoUrl: i.logo_url,
          rank: i.rank,
          moniker: (u = i.description) == null ? void 0 : u.moniker,
          size: "lg"
        }
      ) }),
      /* @__PURE__ */ E("div", { className: "flex flex-col justify-center text-accent-primary", children: [
        l(),
        /* @__PURE__ */ h(X, { as: "div", className: "text-base font-medium text-accent-primary", children: (c = i.description) == null ? void 0 : c.moniker })
      ] })
    ] }),
    s ? /* @__PURE__ */ h(
      "button",
      {
        onClick: () => s(e),
        className: "ml-[10px] cursor-pointer rounded bg-accent-secondary/20 px-2 py-0.5 text-xs tracking-[0.4px] text-accent-primary",
        children: "Remove"
      }
    ) : null
  ] });
}
const xl = ({
  attributes: e,
  providerItemProps: t,
  isSelected: r = !1,
  isSelectable: n = !0,
  onSelect: i
}) => /* @__PURE__ */ E("div", { className: "bg-secondary-highlight h-[316px] overflow-hidden p-4 flex flex-col rounded justify-between", children: [
  /* @__PURE__ */ h(mi, { ...t }),
  /* @__PURE__ */ h("div", { className: "w-full h-px bg-secondary-strokeLight" }),
  Object.entries(e).map(([s, o]) => /* @__PURE__ */ E(
    "div",
    {
      className: "text-sm flex flex-row justify-between first:mt-0 mt-1",
      children: [
        /* @__PURE__ */ h("div", { className: "text-accent-secondary", children: s }),
        /* @__PURE__ */ h("div", { className: "text-accent-primary font-medium", children: o })
      ]
    },
    s
  )),
  i && /* @__PURE__ */ h(
    at,
    {
      className: "mt-4",
      onClick: i,
      disabled: !n,
      variant: r ? "contained" : "outlined",
      children: r ? "Selected" : "Select"
    }
  )
] });
var pt = 1e9, xa = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, Hr, K = !0, Ce = "[DecimalError] ", Qe = Ce + "Invalid argument: ", $r = Ce + "Exponent out of range: ", vt = Math.floor, Ge = Math.pow, Ca = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ve, se = 1e7, G = 7, gi = 9007199254740991, nr = vt(gi / G), T = {};
T.absoluteValue = T.abs = function() {
  var e = new this.constructor(this);
  return e.s && (e.s = 1), e;
};
T.comparedTo = T.cmp = function(e) {
  var t, r, n, i, s = this;
  if (e = new s.constructor(e), s.s !== e.s) return s.s || -e.s;
  if (s.e !== e.e) return s.e > e.e ^ s.s < 0 ? 1 : -1;
  for (n = s.d.length, i = e.d.length, t = 0, r = n < i ? n : i; t < r; ++t)
    if (s.d[t] !== e.d[t]) return s.d[t] > e.d[t] ^ s.s < 0 ? 1 : -1;
  return n === i ? 0 : n > i ^ s.s < 0 ? 1 : -1;
};
T.decimalPlaces = T.dp = function() {
  var e = this, t = e.d.length - 1, r = (t - e.e) * G;
  if (t = e.d[t], t) for (; t % 10 == 0; t /= 10) r--;
  return r < 0 ? 0 : r;
};
T.dividedBy = T.div = function(e) {
  return Re(this, new this.constructor(e));
};
T.dividedToIntegerBy = T.idiv = function(e) {
  var t = this, r = t.constructor;
  return Y(Re(t, new r(e), 0, 1), r.precision);
};
T.equals = T.eq = function(e) {
  return !this.cmp(e);
};
T.exponent = function() {
  return ne(this);
};
T.greaterThan = T.gt = function(e) {
  return this.cmp(e) > 0;
};
T.greaterThanOrEqualTo = T.gte = function(e) {
  return this.cmp(e) >= 0;
};
T.isInteger = T.isint = function() {
  return this.e > this.d.length - 2;
};
T.isNegative = T.isneg = function() {
  return this.s < 0;
};
T.isPositive = T.ispos = function() {
  return this.s > 0;
};
T.isZero = function() {
  return this.s === 0;
};
T.lessThan = T.lt = function(e) {
  return this.cmp(e) < 0;
};
T.lessThanOrEqualTo = T.lte = function(e) {
  return this.cmp(e) < 1;
};
T.logarithm = T.log = function(e) {
  var t, r = this, n = r.constructor, i = n.precision, s = i + 5;
  if (e === void 0)
    e = new n(10);
  else if (e = new n(e), e.s < 1 || e.eq(ve)) throw Error(Ce + "NaN");
  if (r.s < 1) throw Error(Ce + (r.s ? "NaN" : "-Infinity"));
  return r.eq(ve) ? new n(0) : (K = !1, t = Re(St(r, s), St(e, s), s), K = !0, Y(t, i));
};
T.minus = T.sub = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? wi(t, e) : bi(t, (e.s = -e.s, e));
};
T.modulo = T.mod = function(e) {
  var t, r = this, n = r.constructor, i = n.precision;
  if (e = new n(e), !e.s) throw Error(Ce + "NaN");
  return r.s ? (K = !1, t = Re(r, e, 0, 1).times(e), K = !0, r.minus(t)) : Y(new n(r), i);
};
T.naturalExponential = T.exp = function() {
  return yi(this);
};
T.naturalLogarithm = T.ln = function() {
  return St(this);
};
T.negated = T.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s || 0, e;
};
T.plus = T.add = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? bi(t, e) : wi(t, (e.s = -e.s, e));
};
T.precision = T.sd = function(e) {
  var t, r, n, i = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0) throw Error(Qe + e);
  if (t = ne(i) + 1, n = i.d.length - 1, r = n * G + 1, n = i.d[n], n) {
    for (; n % 10 == 0; n /= 10) r--;
    for (n = i.d[0]; n >= 10; n /= 10) r++;
  }
  return e && t > r ? t : r;
};
T.squareRoot = T.sqrt = function() {
  var e, t, r, n, i, s, o, a = this, l = a.constructor;
  if (a.s < 1) {
    if (!a.s) return new l(0);
    throw Error(Ce + "NaN");
  }
  for (e = ne(a), K = !1, i = Math.sqrt(+a), i == 0 || i == 1 / 0 ? (t = Fe(a.d), (t.length + e) % 2 == 0 && (t += "0"), i = Math.sqrt(t), e = vt((e + 1) / 2) - (e < 0 || e % 2), i == 1 / 0 ? t = "5e" + e : (t = i.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + e), n = new l(t)) : n = new l(i.toString()), r = l.precision, i = o = r + 3; ; )
    if (s = n, n = s.plus(Re(a, s, o + 2)).times(0.5), Fe(s.d).slice(0, o) === (t = Fe(n.d)).slice(0, o)) {
      if (t = t.slice(o - 3, o + 1), i == o && t == "4999") {
        if (Y(s, r + 1, 0), s.times(s).eq(a)) {
          n = s;
          break;
        }
      } else if (t != "9999")
        break;
      o += 4;
    }
  return K = !0, Y(n, r);
};
T.times = T.mul = function(e) {
  var t, r, n, i, s, o, a, l, u, c = this, f = c.constructor, p = c.d, m = (e = new f(e)).d;
  if (!c.s || !e.s) return new f(0);
  for (e.s *= c.s, r = c.e + e.e, l = p.length, u = m.length, l < u && (s = p, p = m, m = s, o = l, l = u, u = o), s = [], o = l + u, n = o; n--; ) s.push(0);
  for (n = u; --n >= 0; ) {
    for (t = 0, i = l + n; i > n; )
      a = s[i] + m[n] * p[i - n - 1] + t, s[i--] = a % se | 0, t = a / se | 0;
    s[i] = (s[i] + t) % se | 0;
  }
  for (; !s[--o]; ) s.pop();
  return t ? ++r : s.shift(), e.d = s, e.e = r, K ? Y(e, f.precision) : e;
};
T.toDecimalPlaces = T.todp = function(e, t) {
  var r = this, n = r.constructor;
  return r = new n(r), e === void 0 ? r : (_e(e, 0, pt), t === void 0 ? t = n.rounding : _e(t, 0, 8), Y(r, e + ne(r) + 1, t));
};
T.toExponential = function(e, t) {
  var r, n = this, i = n.constructor;
  return e === void 0 ? r = tt(n, !0) : (_e(e, 0, pt), t === void 0 ? t = i.rounding : _e(t, 0, 8), n = Y(new i(n), e + 1, t), r = tt(n, !0, e + 1)), r;
};
T.toFixed = function(e, t) {
  var r, n, i = this, s = i.constructor;
  return e === void 0 ? tt(i) : (_e(e, 0, pt), t === void 0 ? t = s.rounding : _e(t, 0, 8), n = Y(new s(i), e + ne(i) + 1, t), r = tt(n.abs(), !1, e + ne(n) + 1), i.isneg() && !i.isZero() ? "-" + r : r);
};
T.toInteger = T.toint = function() {
  var e = this, t = e.constructor;
  return Y(new t(e), ne(e) + 1, t.rounding);
};
T.toNumber = function() {
  return +this;
};
T.toPower = T.pow = function(e) {
  var t, r, n, i, s, o, a = this, l = a.constructor, u = 12, c = +(e = new l(e));
  if (!e.s) return new l(ve);
  if (a = new l(a), !a.s) {
    if (e.s < 1) throw Error(Ce + "Infinity");
    return a;
  }
  if (a.eq(ve)) return a;
  if (n = l.precision, e.eq(ve)) return Y(a, n);
  if (t = e.e, r = e.d.length - 1, o = t >= r, s = a.s, o) {
    if ((r = c < 0 ? -c : c) <= gi) {
      for (i = new l(ve), t = Math.ceil(n / G + 4), K = !1; r % 2 && (i = i.times(a), Nn(i.d, t)), r = vt(r / 2), r !== 0; )
        a = a.times(a), Nn(a.d, t);
      return K = !0, e.s < 0 ? new l(ve).div(i) : Y(i, n);
    }
  } else if (s < 0) throw Error(Ce + "NaN");
  return s = s < 0 && e.d[Math.max(t, r)] & 1 ? -1 : 1, a.s = 1, K = !1, i = e.times(St(a, n + u)), K = !0, i = yi(i), i.s = s, i;
};
T.toPrecision = function(e, t) {
  var r, n, i = this, s = i.constructor;
  return e === void 0 ? (r = ne(i), n = tt(i, r <= s.toExpNeg || r >= s.toExpPos)) : (_e(e, 1, pt), t === void 0 ? t = s.rounding : _e(t, 0, 8), i = Y(new s(i), e, t), r = ne(i), n = tt(i, e <= r || r <= s.toExpNeg, e)), n;
};
T.toSignificantDigits = T.tosd = function(e, t) {
  var r = this, n = r.constructor;
  return e === void 0 ? (e = n.precision, t = n.rounding) : (_e(e, 1, pt), t === void 0 ? t = n.rounding : _e(t, 0, 8)), Y(new n(r), e, t);
};
T.toString = T.valueOf = T.val = T.toJSON = T[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var e = this, t = ne(e), r = e.constructor;
  return tt(e, t <= r.toExpNeg || t >= r.toExpPos);
};
function bi(e, t) {
  var r, n, i, s, o, a, l, u, c = e.constructor, f = c.precision;
  if (!e.s || !t.s)
    return t.s || (t = new c(e)), K ? Y(t, f) : t;
  if (l = e.d, u = t.d, o = e.e, i = t.e, l = l.slice(), s = o - i, s) {
    for (s < 0 ? (n = l, s = -s, a = u.length) : (n = u, i = o, a = l.length), o = Math.ceil(f / G), a = o > a ? o + 1 : a + 1, s > a && (s = a, n.length = 1), n.reverse(); s--; ) n.push(0);
    n.reverse();
  }
  for (a = l.length, s = u.length, a - s < 0 && (s = a, n = u, u = l, l = n), r = 0; s; )
    r = (l[--s] = l[s] + u[s] + r) / se | 0, l[s] %= se;
  for (r && (l.unshift(r), ++i), a = l.length; l[--a] == 0; ) l.pop();
  return t.d = l, t.e = i, K ? Y(t, f) : t;
}
function _e(e, t, r) {
  if (e !== ~~e || e < t || e > r)
    throw Error(Qe + e);
}
function Fe(e) {
  var t, r, n, i = e.length - 1, s = "", o = e[0];
  if (i > 0) {
    for (s += o, t = 1; t < i; t++)
      n = e[t] + "", r = G - n.length, r && (s += He(r)), s += n;
    o = e[t], n = o + "", r = G - n.length, r && (s += He(r));
  } else if (o === 0)
    return "0";
  for (; o % 10 === 0; ) o /= 10;
  return s + o;
}
var Re = /* @__PURE__ */ function() {
  function e(n, i) {
    var s, o = 0, a = n.length;
    for (n = n.slice(); a--; )
      s = n[a] * i + o, n[a] = s % se | 0, o = s / se | 0;
    return o && n.unshift(o), n;
  }
  function t(n, i, s, o) {
    var a, l;
    if (s != o)
      l = s > o ? 1 : -1;
    else
      for (a = l = 0; a < s; a++)
        if (n[a] != i[a]) {
          l = n[a] > i[a] ? 1 : -1;
          break;
        }
    return l;
  }
  function r(n, i, s) {
    for (var o = 0; s--; )
      n[s] -= o, o = n[s] < i[s] ? 1 : 0, n[s] = o * se + n[s] - i[s];
    for (; !n[0] && n.length > 1; ) n.shift();
  }
  return function(n, i, s, o) {
    var a, l, u, c, f, p, m, C, b, y, _, w, M, S, L, V, O, $, j = n.constructor, H = n.s == i.s ? 1 : -1, R = n.d, D = i.d;
    if (!n.s) return new j(n);
    if (!i.s) throw Error(Ce + "Division by zero");
    for (l = n.e - i.e, O = D.length, L = R.length, m = new j(H), C = m.d = [], u = 0; D[u] == (R[u] || 0); ) ++u;
    if (D[u] > (R[u] || 0) && --l, s == null ? w = s = j.precision : o ? w = s + (ne(n) - ne(i)) + 1 : w = s, w < 0) return new j(0);
    if (w = w / G + 2 | 0, u = 0, O == 1)
      for (c = 0, D = D[0], w++; (u < L || c) && w--; u++)
        M = c * se + (R[u] || 0), C[u] = M / D | 0, c = M % D | 0;
    else {
      for (c = se / (D[0] + 1) | 0, c > 1 && (D = e(D, c), R = e(R, c), O = D.length, L = R.length), S = O, b = R.slice(0, O), y = b.length; y < O; ) b[y++] = 0;
      $ = D.slice(), $.unshift(0), V = D[0], D[1] >= se / 2 && ++V;
      do
        c = 0, a = t(D, b, O, y), a < 0 ? (_ = b[0], O != y && (_ = _ * se + (b[1] || 0)), c = _ / V | 0, c > 1 ? (c >= se && (c = se - 1), f = e(D, c), p = f.length, y = b.length, a = t(f, b, p, y), a == 1 && (c--, r(f, O < p ? $ : D, p))) : (c == 0 && (a = c = 1), f = D.slice()), p = f.length, p < y && f.unshift(0), r(b, f, y), a == -1 && (y = b.length, a = t(D, b, O, y), a < 1 && (c++, r(b, O < y ? $ : D, y))), y = b.length) : a === 0 && (c++, b = [0]), C[u++] = c, a && b[0] ? b[y++] = R[S] || 0 : (b = [R[S]], y = 1);
      while ((S++ < L || b[0] !== void 0) && w--);
    }
    return C[0] || C.shift(), m.e = l, Y(m, o ? s + ne(m) + 1 : s);
  };
}();
function yi(e, t) {
  var r, n, i, s, o, a, l = 0, u = 0, c = e.constructor, f = c.precision;
  if (ne(e) > 16) throw Error($r + ne(e));
  if (!e.s) return new c(ve);
  for (K = !1, a = f, o = new c(0.03125); e.abs().gte(0.1); )
    e = e.times(o), u += 5;
  for (n = Math.log(Ge(2, u)) / Math.LN10 * 2 + 5 | 0, a += n, r = i = s = new c(ve), c.precision = a; ; ) {
    if (i = Y(i.times(e), a), r = r.times(++l), o = s.plus(Re(i, r, a)), Fe(o.d).slice(0, a) === Fe(s.d).slice(0, a)) {
      for (; u--; ) s = Y(s.times(s), a);
      return c.precision = f, t == null ? (K = !0, Y(s, f)) : s;
    }
    s = o;
  }
}
function ne(e) {
  for (var t = e.e * G, r = e.d[0]; r >= 10; r /= 10) t++;
  return t;
}
function hr(e, t, r) {
  if (t > e.LN10.sd())
    throw K = !0, r && (e.precision = r), Error(Ce + "LN10 precision limit exceeded");
  return Y(new e(e.LN10), t);
}
function He(e) {
  for (var t = ""; e--; ) t += "0";
  return t;
}
function St(e, t) {
  var r, n, i, s, o, a, l, u, c, f = 1, p = 10, m = e, C = m.d, b = m.constructor, y = b.precision;
  if (m.s < 1) throw Error(Ce + (m.s ? "NaN" : "-Infinity"));
  if (m.eq(ve)) return new b(0);
  if (t == null ? (K = !1, u = y) : u = t, m.eq(10))
    return t == null && (K = !0), hr(b, u);
  if (u += p, b.precision = u, r = Fe(C), n = r.charAt(0), s = ne(m), Math.abs(s) < 15e14) {
    for (; n < 7 && n != 1 || n == 1 && r.charAt(1) > 3; )
      m = m.times(e), r = Fe(m.d), n = r.charAt(0), f++;
    s = ne(m), n > 1 ? (m = new b("0." + r), s++) : m = new b(n + "." + r.slice(1));
  } else
    return l = hr(b, u + 2, y).times(s + ""), m = St(new b(n + "." + r.slice(1)), u - p).plus(l), b.precision = y, t == null ? (K = !0, Y(m, y)) : m;
  for (a = o = m = Re(m.minus(ve), m.plus(ve), u), c = Y(m.times(m), u), i = 3; ; ) {
    if (o = Y(o.times(c), u), l = a.plus(Re(o, new b(i), u)), Fe(l.d).slice(0, u) === Fe(a.d).slice(0, u))
      return a = a.times(2), s !== 0 && (a = a.plus(hr(b, u + 2, y).times(s + ""))), a = Re(a, new b(f), u), b.precision = y, t == null ? (K = !0, Y(a, y)) : a;
    a = l, i += 2;
  }
}
function Cn(e, t) {
  var r, n, i;
  for ((r = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (n = t.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +t.slice(n + 1), t = t.substring(0, n)) : r < 0 && (r = t.length), n = 0; t.charCodeAt(n) === 48; ) ++n;
  for (i = t.length; t.charCodeAt(i - 1) === 48; ) --i;
  if (t = t.slice(n, i), t) {
    if (i -= n, r = r - n - 1, e.e = vt(r / G), e.d = [], n = (r + 1) % G, r < 0 && (n += G), n < i) {
      for (n && e.d.push(+t.slice(0, n)), i -= G; n < i; ) e.d.push(+t.slice(n, n += G));
      t = t.slice(n), n = G - t.length;
    } else
      n -= i;
    for (; n--; ) t += "0";
    if (e.d.push(+t), K && (e.e > nr || e.e < -nr)) throw Error($r + r);
  } else
    e.s = 0, e.e = 0, e.d = [0];
  return e;
}
function Y(e, t, r) {
  var n, i, s, o, a, l, u, c, f = e.d;
  for (o = 1, s = f[0]; s >= 10; s /= 10) o++;
  if (n = t - o, n < 0)
    n += G, i = t, u = f[c = 0];
  else {
    if (c = Math.ceil((n + 1) / G), s = f.length, c >= s) return e;
    for (u = s = f[c], o = 1; s >= 10; s /= 10) o++;
    n %= G, i = n - G + o;
  }
  if (r !== void 0 && (s = Ge(10, o - i - 1), a = u / s % 10 | 0, l = t < 0 || f[c + 1] !== void 0 || u % s, l = r < 4 ? (a || l) && (r == 0 || r == (e.s < 0 ? 3 : 2)) : a > 5 || a == 5 && (r == 4 || l || r == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (n > 0 ? i > 0 ? u / Ge(10, o - i) : 0 : f[c - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7))), t < 1 || !f[0])
    return l ? (s = ne(e), f.length = 1, t = t - s - 1, f[0] = Ge(10, (G - t % G) % G), e.e = vt(-t / G) || 0) : (f.length = 1, f[0] = e.e = e.s = 0), e;
  if (n == 0 ? (f.length = c, s = 1, c--) : (f.length = c + 1, s = Ge(10, G - n), f[c] = i > 0 ? (u / Ge(10, o - i) % Ge(10, i) | 0) * s : 0), l)
    for (; ; )
      if (c == 0) {
        (f[0] += s) == se && (f[0] = 1, ++e.e);
        break;
      } else {
        if (f[c] += s, f[c] != se) break;
        f[c--] = 0, s = 1;
      }
  for (n = f.length; f[--n] === 0; ) f.pop();
  if (K && (e.e > nr || e.e < -nr))
    throw Error($r + ne(e));
  return e;
}
function wi(e, t) {
  var r, n, i, s, o, a, l, u, c, f, p = e.constructor, m = p.precision;
  if (!e.s || !t.s)
    return t.s ? t.s = -t.s : t = new p(e), K ? Y(t, m) : t;
  if (l = e.d, f = t.d, n = t.e, u = e.e, l = l.slice(), o = u - n, o) {
    for (c = o < 0, c ? (r = l, o = -o, a = f.length) : (r = f, n = u, a = l.length), i = Math.max(Math.ceil(m / G), a) + 2, o > i && (o = i, r.length = 1), r.reverse(), i = o; i--; ) r.push(0);
    r.reverse();
  } else {
    for (i = l.length, a = f.length, c = i < a, c && (a = i), i = 0; i < a; i++)
      if (l[i] != f[i]) {
        c = l[i] < f[i];
        break;
      }
    o = 0;
  }
  for (c && (r = l, l = f, f = r, t.s = -t.s), a = l.length, i = f.length - a; i > 0; --i) l[a++] = 0;
  for (i = f.length; i > o; ) {
    if (l[--i] < f[i]) {
      for (s = i; s && l[--s] === 0; ) l[s] = se - 1;
      --l[s], l[i] += se;
    }
    l[i] -= f[i];
  }
  for (; l[--a] === 0; ) l.pop();
  for (; l[0] === 0; l.shift()) --n;
  return l[0] ? (t.d = l, t.e = n, K ? Y(t, m) : t) : new p(0);
}
function tt(e, t, r) {
  var n, i = ne(e), s = Fe(e.d), o = s.length;
  return t ? (r && (n = r - o) > 0 ? s = s.charAt(0) + "." + s.slice(1) + He(n) : o > 1 && (s = s.charAt(0) + "." + s.slice(1)), s = s + (i < 0 ? "e" : "e+") + i) : i < 0 ? (s = "0." + He(-i - 1) + s, r && (n = r - o) > 0 && (s += He(n))) : i >= o ? (s += He(i + 1 - o), r && (n = r - i - 1) > 0 && (s = s + "." + He(n))) : ((n = i + 1) < o && (s = s.slice(0, n) + "." + s.slice(n)), r && (n = r - o) > 0 && (i + 1 === o && (s += "."), s += He(n))), e.s < 0 ? "-" + s : s;
}
function Nn(e, t) {
  if (e.length > t)
    return e.length = t, !0;
}
function xi(e) {
  var t, r, n;
  function i(s) {
    var o = this;
    if (!(o instanceof i)) return new i(s);
    if (o.constructor = i, s instanceof i) {
      o.s = s.s, o.e = s.e, o.d = (s = s.d) ? s.slice() : s;
      return;
    }
    if (typeof s == "number") {
      if (s * 0 !== 0)
        throw Error(Qe + s);
      if (s > 0)
        o.s = 1;
      else if (s < 0)
        s = -s, o.s = -1;
      else {
        o.s = 0, o.e = 0, o.d = [0];
        return;
      }
      if (s === ~~s && s < 1e7) {
        o.e = 0, o.d = [s];
        return;
      }
      return Cn(o, s.toString());
    } else if (typeof s != "string")
      throw Error(Qe + s);
    if (s.charCodeAt(0) === 45 ? (s = s.slice(1), o.s = -1) : o.s = 1, Ca.test(s)) Cn(o, s);
    else throw Error(Qe + s);
  }
  if (i.prototype = T, i.ROUND_UP = 0, i.ROUND_DOWN = 1, i.ROUND_CEIL = 2, i.ROUND_FLOOR = 3, i.ROUND_HALF_UP = 4, i.ROUND_HALF_DOWN = 5, i.ROUND_HALF_EVEN = 6, i.ROUND_HALF_CEIL = 7, i.ROUND_HALF_FLOOR = 8, i.clone = xi, i.config = i.set = Na, e === void 0 && (e = {}), e)
    for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], t = 0; t < n.length; ) e.hasOwnProperty(r = n[t++]) || (e[r] = this[r]);
  return i.config(e), i;
}
function Na(e) {
  if (!e || typeof e != "object")
    throw Error(Ce + "Object expected");
  var t, r, n, i = [
    "precision",
    1,
    pt,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (t = 0; t < i.length; t += 3)
    if ((n = e[r = i[t]]) !== void 0)
      if (vt(n) === n && n >= i[t + 1] && n <= i[t + 2]) this[r] = n;
      else throw Error(Qe + r + ": " + n);
  if ((n = e[r = "LN10"]) !== void 0)
    if (n == Math.LN10) this[r] = new this(n);
    else throw Error(Qe + r + ": " + n);
  return this;
}
var Hr = xi(xa);
ve = new Hr(1);
const Oa = {
  prefix: "$",
  precision: 2,
  zeroDisplay: "-",
  format: {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }
};
function ka(e, t = {}) {
  const { prefix: r, precision: n, zeroDisplay: i, format: s } = {
    ...Oa,
    ...t
  };
  if (e === 0) return i;
  const o = e.toLocaleString("en", s ?? { maximumFractionDigits: n });
  return `${r}${o}`;
}
function Ea(e, t, r) {
  const n = e * t;
  return ka(n, r);
}
const Sa = (e, t, r) => new Hr(e).toDecimalPlaces(t, r).toNumber(), Ur = 8, Aa = 5, Cl = ({
  fieldName: e,
  currencyIcon: t,
  currencyName: r,
  displayBalance: n,
  placeholder: i = "Enter Amount",
  balanceDetails: s,
  min: o = "0",
  step: a = "any",
  autoFocus: l = !0
}) => {
  const u = ai({ name: e, defaultValue: "" }), { setValue: c } = dt(), f = parseFloat(u || "0"), p = Ea(f, (s == null ? void 0 : s.price) ?? 0, {
    zeroDisplay: "$0.00"
  });
  return /* @__PURE__ */ E(Dr, { className: "flex w-full flex-col content-center justify-between gap-4", children: [
    /* @__PURE__ */ E("div", { className: "flex w-full flex-row content-center items-center justify-between font-normal", children: [
      /* @__PURE__ */ E("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ h("img", { src: t, alt: r, className: "h-10 max-h-[2.5rem] w-10 max-w-[2.5rem]" }),
        /* @__PURE__ */ h("div", { className: "text-lg", children: r })
      ] }),
      /* @__PURE__ */ h(
        "input",
        {
          type: "number",
          value: u ?? "",
          min: o,
          step: a,
          onChange: (b) => {
            c(e, b.target.value, {
              shouldValidate: !0,
              shouldDirty: !0,
              shouldTouch: !0
            });
          },
          onKeyDown: (b) => {
            (b.key === "ArrowUp" || b.key === "ArrowDown") && b.preventDefault();
          },
          placeholder: i,
          autoFocus: l,
          className: "w-2/3 bg-transparent text-right text-lg outline-none appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
        }
      )
    ] }),
    /* @__PURE__ */ h(ba, { name: e, defaultValue: "" }),
    s && n ? /* @__PURE__ */ E("div", { className: "flex w-full flex-row content-center justify-between text-sm", children: [
      /* @__PURE__ */ E("div", { children: [
        "Stakable:",
        " ",
        /* @__PURE__ */ h("span", { className: "cursor-default", children: Sa(Number(s.balance), s.decimals ?? Ur) }),
        " ",
        s.symbol
      ] }),
      s.displayUSD && s.price !== void 0 && /* @__PURE__ */ E("div", { children: [
        p,
        " USD"
      ] })
    ] }) : null
  ] });
};
function Fa({ items: e, onRemove: t }) {
  const r = We(() => e, [e]);
  return r.length === 0 ? null : /* @__PURE__ */ h("div", { className: "flex flex-col gap-8", children: r.map(({ bsnId: n, bsnName: i, bsnLogoUrl: s, provider: o }) => /* @__PURE__ */ h(
    mi,
    {
      bsnId: n,
      bsnName: i,
      bsnLogoUrl: s,
      provider: o,
      onRemove: t
    },
    `${n}-${o.rank}`
  )) });
}
function Nl({ max: e, items: t = [], actionText: r, onAdd: n, onRemove: i }) {
  const s = We(() => t.length, [t]);
  return /* @__PURE__ */ h(Dr, { children: /* @__PURE__ */ E("div", { className: "flex w-full flex-col gap-4", children: [
    /* @__PURE__ */ h("div", { className: "flex flex-row", children: /* @__PURE__ */ E("div", { className: "flex w-full flex-row content-center items-center justify-between font-normal", children: [
      /* @__PURE__ */ h("span", { className: "text-sm sm:text-base", children: r }),
      /* @__PURE__ */ h(Uo, { counter: s, max: e, onAdd: n })
    ] }) }),
    s > 0 && /* @__PURE__ */ h(Fa, { items: t, onRemove: i })
  ] }) });
}
function Wr({ title: e, children: t, className: r, hint: n }) {
  return /* @__PURE__ */ E(
    "div",
    {
      className: be(
        "flex flex-row items-center justify-between text-accent-primary",
        n && "items-start",
        r
      ),
      children: [
        /* @__PURE__ */ h(X, { as: "div", variant: "body1", children: e }),
        n ? /* @__PURE__ */ E("div", { className: "flex flex-col items-end", children: [
          /* @__PURE__ */ h(X, { as: "div", className: "flex items-center gap-2", children: t }),
          /* @__PURE__ */ h(X, { as: "div", variant: "body2", className: "text-accent-secondary", children: n })
        ] }) : /* @__PURE__ */ h(X, { as: "div", className: "flex items-center gap-2", children: t })
      ]
    }
  );
}
function La(e) {
  return Vt({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z" }, child: [] }] })(e);
}
function Va({ value: e, onEdit: t, title: r = "Network Fee Rate", className: n }) {
  return /* @__PURE__ */ E(Wr, { title: r, className: n, children: [
    /* @__PURE__ */ E("span", { children: [
      e,
      " sats/vB"
    ] }),
    t && /* @__PURE__ */ h(at, { size: "small", variant: "outlined", className: "h-6 w-6 pl-1 text-secondary-strokeDark", onClick: t, children: /* @__PURE__ */ h(La, { size: 16, className: "text-secondary-strokeDark" }) })
  ] });
}
function _a({ amount: e, coinSymbol: t, hint: r, title: n, className: i, decimals: s = Ur }) {
  let o;
  return typeof e == "number" ? e === 0 ? o = "0" : o = e.toFixed(s).replace(/0+$/, "").replace(/\.$/, "") : o = e, /* @__PURE__ */ E(Wr, { title: n ?? `${t} Network Fee`, hint: r, className: i, children: [
    o,
    " ",
    t
  ] });
}
function Da({ amount: e, coinSymbol: t, hint: r, title: n, className: i, decimals: s = Aa }) {
  const o = typeof e == "number" ? e.toFixed(s) : e;
  return /* @__PURE__ */ E(Wr, { title: n ?? `${t} Network Fee`, hint: r, className: i, children: [
    o,
    " ",
    t
  ] });
}
function Ta({ total: e, coinSymbol: t, hint: r, title: n = "Total", className: i, decimals: s = Ur }) {
  let o;
  return typeof e == "number" ? e === 0 ? o = "0" : o = e.toFixed(s).replace(/0+$/, "").replace(/\.$/, "") : o = e, /* @__PURE__ */ E("div", { className: be("flex flex-row items-start justify-between text-accent-primary", i), children: [
    /* @__PURE__ */ h(X, { variant: "body1", className: "font-bold", children: n }),
    /* @__PURE__ */ E("div", { className: "flex flex-col items-end justify-center", children: [
      /* @__PURE__ */ E(X, { variant: "body1", className: "font-bold", children: [
        o,
        " ",
        t
      ] }),
      r && /* @__PURE__ */ h(X, { variant: "body1", className: "text-sm text-accent-secondary", children: r })
    ] })
  ] });
}
function Ol({
  className: e,
  feeRate: t,
  onFeeRateEdit: r,
  feeAmount: n,
  coinSymbol: i,
  feeAmountHint: s,
  total: o,
  totalHint: a,
  bbnFeeAmount: l,
  bbnCoinSymbol: u,
  bbnFeeAmountHint: c,
  bbnFeeDecimals: f
}) {
  return /* @__PURE__ */ h(Dr, { className: be("flex w-full flex-col content-center justify-between gap-4", e), children: /* @__PURE__ */ E("div", { className: "flex flex-col gap-6 p-4", children: [
    /* @__PURE__ */ h(Va, { value: t, onEdit: r }),
    /* @__PURE__ */ h(_a, { amount: n, coinSymbol: i, hint: s }),
    l !== void 0 && u ? /* @__PURE__ */ h(
      Da,
      {
        amount: l,
        coinSymbol: u,
        hint: c,
        decimals: f
      }
    ) : null,
    /* @__PURE__ */ h("div", { className: "divider my-4" }),
    /* @__PURE__ */ h(Ta, { total: o, coinSymbol: i, hint: a })
  ] }) });
}
const On = (e) => {
  let t = "";
  for (let r = 0; r < e.length; r++) {
    const n = e[r].toLowerCase();
    n >= "a" && n <= "z" || n >= "0" && n <= "9" ? t += n : t.length > 0 && t[t.length - 1] !== "-" && (t += "-");
  }
  return t.endsWith("-") && (t = t.slice(0, -1)), t;
}, Ma = 640;
function Pa({ className: e, ...t }) {
  const n = ei(Ma) ? Zn : uo;
  return /* @__PURE__ */ h(n, { ...t, className: be("w-[41.25rem] max-w-full", e) });
}
const kl = ({
  open: e,
  processing: t = !1,
  onClose: r,
  onProceed: n,
  bsns: i,
  finalityProviders: s,
  details: o
}) => {
  const a = [
    { label: "Stake Amount", value: o.stakeAmount },
    { label: "Fee Rate", value: o.feeRate },
    { label: "Transaction Fees", value: o.transactionFees },
    {
      label: "Term",
      value: /* @__PURE__ */ E(Ft, { children: [
        o.term.blocks,
        /* @__PURE__ */ h("br", {}),
        /* @__PURE__ */ h("span", { className: "text-md text-secondary", children: o.term.duration })
      ] })
    },
    { label: "Unbonding", value: o.unbonding },
    { label: "Unbonding Fee", value: o.unbondingFee }
  ];
  return /* @__PURE__ */ E(Pa, { open: e, onClose: r, children: [
    /* @__PURE__ */ h(ho, { title: "Preview", onClose: r, className: "text-accent-primary" }),
    /* @__PURE__ */ E(po, { className: "no-scrollbar mb-8 mt-4 flex max-h-[calc(100vh-12rem)] flex-col gap-4 overflow-y-auto text-accent-primary", children: [
      /* @__PURE__ */ h(Io, { className: "p-6 pt-4", children: /* @__PURE__ */ E("div", { className: "flex flex-col", children: [
        i.length > 1 ? /* @__PURE__ */ E("div", { className: "grid grid-cols-2 items-center gap-4 pb-4", children: [
          /* @__PURE__ */ h(X, { variant: "caption", className: "text-secondary text-center", children: "BSNs" }),
          /* @__PURE__ */ h(X, { variant: "caption", className: "text-secondary text-center", children: "Finality Provider" })
        ] }) : null,
        /* @__PURE__ */ E("div", { className: "grid grid-cols-2 items-center gap-4 rounded bg-primary-contrast p-4", children: [
          /* @__PURE__ */ h("div", { className: "flex flex-col gap-3", children: i.map((l, u) => /* @__PURE__ */ E("div", { className: "flex w-full items-center justify-center gap-2 py-1", children: [
            l.icon,
            /* @__PURE__ */ h(X, { variant: "body2", className: "font-medium", children: l.name })
          ] }, `bsn-${On(l.name)}-${u}`)) }),
          /* @__PURE__ */ h("div", { className: "flex flex-col gap-3", children: s.map((l, u) => /* @__PURE__ */ E("div", { className: "flex w-full items-center justify-center gap-2 py-1", children: [
            l.icon,
            /* @__PURE__ */ h(X, { variant: "body2", className: "font-medium", children: l.name })
          ] }, `fp-${On(l.name)}-${u}`)) })
        ] })
      ] }) }),
      /* @__PURE__ */ h("div", { className: "flex flex-col", children: a.map((l, u) => /* @__PURE__ */ E("div", { className: "flex flex-row items-center justify-between py-3", children: [
        /* @__PURE__ */ h(X, { variant: "body1", className: "text-secondary font-normal", children: l.label }),
        /* @__PURE__ */ h(X, { variant: "body1", className: "text-right font-normal", children: l.value })
      ] }, u)) }),
      /* @__PURE__ */ h("div", { className: "border-divider w-full border-t" }),
      /* @__PURE__ */ E("div", { className: "pt-2", children: [
        /* @__PURE__ */ h(Nr, { variant: "h6", className: "text-primary mb-2", children: "Attention!" }),
        /* @__PURE__ */ h(X, { variant: "body2", className: "text-secondary", children: "1. No third party possesses your staked BTC. You are the only one who can unbond and withdraw your stake." }),
        /* @__PURE__ */ h(X, { variant: "body2", className: "text-secondary", children: "2. Your stake will first be sent to Babylon Genesis for verification (~20 seconds), then you will be prompted to submit it to the Bitcoin ledger. It will be marked as 'Pending' until it receives 10 Bitcoin confirmations." })
      ] })
    ] }),
    /* @__PURE__ */ E(vo, { className: "flex flex-col gap-4 pb-8 pt-0 sm:flex-row", children: [
      /* @__PURE__ */ h(at, { variant: "contained", color: "primary", onClick: n, className: "w-full sm:flex-1 sm:order-2", disabled: t, children: t ? "Processing..." : "Proceed to Signing" }),
      /* @__PURE__ */ h(at, { variant: "outlined", color: "primary", onClick: r, className: "w-full sm:flex-1 sm:order-1", children: "Cancel" })
    ] })
  ] });
}, Ra = ({ size: e = "md" }) => /* @__PURE__ */ h("div", { className: {
  sm: "mt-2",
  md: "mt-4",
  lg: "mt-6"
}[e] }), Ba = () => /* @__PURE__ */ h("svg", { width: "29", height: "28", viewBox: "0 0 29 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h(
  "path",
  {
    d: "M24.9127 15.3708C24.9711 14.9333 25.0002 14.4812 25.0002 14C25.0002 13.5333 24.9711 13.0667 24.8982 12.6292L27.8586 10.325C28.1211 10.1208 28.194 9.72708 28.0336 9.43542L25.2336 4.59375C25.0586 4.27292 24.694 4.17083 24.3732 4.27292L20.8877 5.67292C20.1586 5.11875 19.3857 4.65208 18.5252 4.30208L18.0002 0.597916C17.9419 0.247916 17.6502 0 17.3002 0H11.7002C11.3502 0 11.0732 0.247916 11.0148 0.597916L10.4898 4.30208C9.62941 4.65208 8.84191 5.13333 8.12732 5.67292L4.64191 4.27292C4.32107 4.15625 3.95649 4.27292 3.78149 4.59375L0.996075 9.43542C0.821075 9.74167 0.879408 10.1208 1.17107 10.325L4.13149 12.6292C4.05857 13.0667 4.00024 13.5479 4.00024 14C4.00024 14.4521 4.02941 14.9333 4.10232 15.3708L1.14191 17.675C0.879408 17.8792 0.806491 18.2729 0.966908 18.5646L3.76691 23.4062C3.94191 23.7271 4.30649 23.8292 4.62732 23.7271L8.11274 22.3271C8.84191 22.8812 9.61482 23.3479 10.4752 23.6979L11.0002 27.4021C11.0732 27.7521 11.3502 28 11.7002 28H17.3002C17.6502 28 17.9419 27.7521 17.9857 27.4021L18.5107 23.6979C19.3711 23.3479 20.1586 22.8812 20.8732 22.3271L24.3586 23.7271C24.6794 23.8438 25.044 23.7271 25.219 23.4062L28.019 18.5646C28.194 18.2437 28.1211 17.8792 27.844 17.675L24.9127 15.3708ZM14.5002 19.25C11.6127 19.25 9.25024 16.8875 9.25024 14C9.25024 11.1125 11.6127 8.75 14.5002 8.75C17.3877 8.75 19.7502 11.1125 19.7502 14C19.7502 16.8875 17.3877 19.25 14.5002 19.25Z",
    fill: "#9E9E9E"
  }
) }), Ci = () => /* @__PURE__ */ h("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h("path", { d: "M9 18L15 12L9 6", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) }), ja = ({ children: e, className: t = "" }) => /* @__PURE__ */ h(X, { variant: "body1", className: F("px-7 pb-6 text-accent-primary md:hidden", t), children: e }), Ia = ({
  background: e = "none",
  backgroundClassName: t = "",
  className: r = "",
  children: n
}) => /* @__PURE__ */ h("div", { className: F((() => {
  switch (e) {
    case "secondary":
      return "mx-[21px] rounded-lg bg-secondary-highlight md:mx-0 md:bg-transparent";
    case "custom":
      return t;
    default:
      return "";
  }
})(), r), children: n }), At = ({ children: e }) => /* @__PURE__ */ h(Ft, { children: e }), Ni = ({
  icon: e,
  suffix: t,
  onClick: r,
  disabled: n = !1,
  selected: i = !1,
  className: s = "",
  children: o
}) => {
  const a = B.Children.toArray(o), l = a.find(
    (p) => typeof p == "string" || B.isValidElement(p) && p.type !== At
  ), u = a.find(
    (p) => B.isValidElement(p) && p.type === At
  ), c = typeof l == "string" ? l : "", f = r ? /* @__PURE__ */ h(Ci, {}) : void 0;
  return /* @__PURE__ */ h(
    zo,
    {
      icon: e,
      name: c,
      description: u ? u.props.children : void 0,
      onClick: r,
      disabled: n,
      selected: i,
      className: s,
      suffix: t || f
    }
  );
}, $a = ({ icon: e, className: t = "", children: r }) => {
  const n = B.Children.toArray(r), i = n.find(
    (l) => typeof l == "string" || B.isValidElement(l) && l.type !== At
  ), s = n.find(
    (l) => B.isValidElement(l) && l.type === At
  ), o = n.filter((l) => B.isValidElement(l) && l.type === Ni);
  return /* @__PURE__ */ h(
    Zo,
    {
      icon: e,
      name: typeof i == "string" ? i : "",
      description: s ? s.props.children : void 0,
      className: t,
      suffix: /* @__PURE__ */ h(Ci, {}),
      children: o
    }
  );
}, Ha = ({ children: e, className: t = "" }) => /* @__PURE__ */ h("div", { className: t, children: e }), Ua = ({
  trigger: e,
  open: t,
  onOpenChange: r,
  placement: n = "bottom-end",
  className: i,
  offset: s = [0, 8],
  children: o
}) => /* @__PURE__ */ h(
  qo,
  {
    trigger: e || /* @__PURE__ */ h(
      "button",
      {
        className: "flex h-10 w-10 items-center justify-center rounded-lg transition-colors hover:bg-accent-primary/10",
        "aria-label": "Settings menu",
        children: /* @__PURE__ */ h(Ba, {})
      }
    ),
    open: t,
    onOpenChange: r,
    placement: n,
    className: i,
    offset: s,
    children: o
  }
), nt = Ua;
nt.Title = ja;
nt.Group = Ia;
nt.Item = Ni;
nt.SubMenu = $a;
nt.Description = At;
nt.CustomContent = Ha;
nt.Spacer = Ra;
const Wa = {
  adaptive: "adaptive",
  horizontal: "vertical",
  vertical: "horizontal"
};
function El({ className: e, orientation: t = "vertical", children: r }) {
  return /* @__PURE__ */ h("div", { className: be("bbn-list-legacy", `bbn-list-legacy-${t}`, e), children: Xt.map(
    r,
    (n) => wr(n) ? yr(n, {
      orientation: Wa[t]
    }) : n
  ) });
}
function Sl({ className: e, orientation: t = "horizontal", title: r, value: n, suffix: i }) {
  return /* @__PURE__ */ E("div", { className: F("bbn-list-item-legacy", `bbn-list-item-legacy-${t}`, e), children: [
    /* @__PURE__ */ h(
      X,
      {
        as: "div",
        className: F("bbn-list-title-legacy", `bbn-list-title-legacy-${t}`),
        variant: t === "horizontal" ? "body1" : "body2",
        children: r
      }
    ),
    /* @__PURE__ */ E(
      X,
      {
        as: "div",
        className: F("bbn-list-value-legacy", `bbn-list-value-legacy-${t}`),
        variant: "body1",
        children: [
          n,
          i
        ]
      }
    )
  ] });
}
export {
  Ya as Accordion,
  Ka as AccordionDetails,
  Ga as AccordionSummary,
  Cl as AmountSubsection,
  pr as Avatar,
  Ja as AvatarGroup,
  Da as BBNFeeAmount,
  _a as BTCFeeAmount,
  Va as BTCFeeRate,
  ul as Badge,
  el as BitcoinPublicKeyIcon,
  at as Button,
  Io as Card,
  Ro as Cell,
  _i as Checkbox,
  bl as CheckboxField,
  il as Chip,
  fo as CloseIcon,
  Mo as Column,
  hl as Copy,
  nl as CopyIcon,
  Uo as CounterButton,
  uo as Dialog,
  po as DialogBody,
  vo as DialogFooter,
  ho as DialogHeader,
  dl as DisplayHash,
  Wr as FeeItem,
  Ol as FeesSection,
  mi as FinalityProviderItem,
  wa as FinalityProviderLogo,
  Nl as FinalityProviderSubsection,
  pl as Form,
  ar as FormControl,
  Nr as Heading,
  ba as HiddenField,
  Sn as IconButton,
  Vr as Input,
  tl as LinkWalletIcon,
  ll as List,
  cl as ListItem,
  Sl as ListItemLegacy,
  El as ListLegacy,
  sl as Loader,
  qo as Menu,
  Qn as MenuDrawer,
  zo as MenuItem,
  Zn as MobileDialog,
  ml as NumberField,
  $n as Popover,
  or as Portal,
  kl as PreviewModal,
  Ti as Radio,
  yl as RadioField,
  Qa as ScrollLocker,
  Hn as Select,
  wl as SelectField,
  nt as SettingMenu,
  Ha as SettingMenuCustomContent,
  At as SettingMenuDescription,
  Ia as SettingMenuGroup,
  Ni as SettingMenuItem,
  $a as SettingMenuSubMenu,
  ja as SettingMenuTitle,
  Zo as SubMenu,
  fl as SubMenuItem,
  Dr as SubSection,
  ol as Table,
  xl as TableElement,
  X as Text,
  gl as TextField,
  _r as ThemedIcon,
  al as Toggle,
  Ta as Total,
  rl as UsingInscriptionIcon,
  Fi as WalletDisconnectButton,
  zn as iconColorVariants,
  ao as useClickOutside,
  ot as useControlledState,
  Yo as useCopy,
  ht as useField,
  vl as useFieldState,
  dt as useFormContext,
  si as useFormState,
  ei as useIsMobile,
  oo as useMemoizedArray,
  Jn as useMenuContext,
  Wn as useModalManager,
  lo as useResizeObserver,
  To as useTableScroll,
  Po as useTableSort,
  ai as useWatch
};
//# sourceMappingURL=index.es.js.map
